export default {
    // 中
    zhCN: {
        customs_declaration_unit: '报关单位',
        theme: '主题',
        model: '型号',
        problem_state: '问题状态',
        TAC_submit_date: 'TAC提交日期',
        level: '级别',
        type: '类型',
        vehicle_involved: '涉及活动',
        activity_code: '活动代码',
        activity_name: '活动名称',
        connected_activities: '关联活动',
        connected_activities_remarks: '关联活动说明',
        system_problems: '系统问题',
        quantity: '数量',
        engine_type: '发动机类型',
        gearbox_type: '变速箱类型',
        reporting_country: '上报国家',
        region: '上报地区',
        date_of_feedback_to_QA: '反馈到QA日期',
        required_part_return_date: '要求零件返回日期',
        date_of_parts_delivery_to_QA: '零件交付到QA日期',
        solution_release_date: '解决方案发布日期',
        solution_target_date: '解决方案目标日期',
        end_date: '结束日期',
        difference: '差异',
        QA_weekday: 'QA工作日',
        fault_description: '故障描述',
        root_cause: '根本原因',
        production_line_measures_Breakpoint: '产线措施/断点',
        breakpoint: '售后措施/断点',
        process: '最新进展',
        technical_document_attachments: '技术文档附件',
        connected_activities_required: '请选择关联活动',
        fault_desc_placeholder:
            'a、道路情况、驾驶工况、客户操作、仪表提示、车辆表现 \n' +
            'b、检查过程、故障是否复现、互换及结果、车辆修复情况等',
        production_line_measures_Breakpoint_placeholder: '产线改进方案及产线/零件断点信息',
        breakpoint_placeholder: '售后维修方案，售后方案释放时间',
        process_placeholder:
            'a、案例上升情况 \n' +
            'b、零件回运情况 \n' +
            'c、原因分析计划 \n' +
            'd、解决措施 \n' +
            'e、活动开展情况 \n' +
            'f、案例关闭情况等',
        historical_information: '历史信息',
        is_intensive_monitoring: '是否重点跟踪',
        partOrSoftwareNum: '零件号/软件版本号',
        closeDate: '关闭时间',
        original_content: '修改前内容',
        modified_time: '修改时间',
        modified_by: '修改人',
        exp_doc_details: '单据明细导出',
        exp_report_data: '报表数据导出',
    },
    // 英
    enUS: {
        customs_declaration_unit: 'Customs declaration unit',
        theme: 'Theme',
        model: 'Model',
        problem_state: 'Problem state',
        TAC_submit_date: 'TAC submit date',
        level: 'Level',
        type: 'Type',
        vehicle_involved: 'Involved in activities',
        activity_code: 'Activity code',
        activity_name: 'Activity name',
        connected_activities: 'Connected activities',
        connected_activities_remarks: 'Connected activities description',
        system_problems: 'System problems',
        quantity: 'Quantity',
        engine_type: 'Engine type',
        gearbox_type: 'Gearbox type',
        reporting_country: 'Reporting country',
        region: 'Reporting Region',
        date_of_feedback_to_QA: 'Date of feedback to QA',
        required_part_return_date: 'Required part return date',
        date_of_parts_delivery_to_QA: 'Date of select delivery to QA',
        solution_release_date: 'Solution release date',
        solution_target_date: 'Solution target date',
        end_date: 'End date',
        difference: 'Difference',
        QA_weekday: 'QA weekday',
        fault_description: 'Fault description',
        root_cause: 'Root Cause',
        production_line_measures_Breakpoint: 'Production Line Measures/Breakpoint',
        breakpoint: 'After-Sales Measures/Breakpoint',
        process: 'Latest progress',
        technical_document_attachments: 'Technical document attachments',
        connected_activities_required: 'Please select an associated activity',
        fault_desc_placeholder:
            'a. Road conditions, Driving conditions, Customer operations, Instrument prompts, Vehicle performance. \n' +
            'b. Inspection process, Reproduction of faults, Interchange and results, Vehicle repair situation, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Production Line Improvement Plan && Production Line/Part Breakpoint Information',
        breakpoint_placeholder: 'After-Sales Maintenance Plan , After-Sales Plan Release Time',
        process_placeholder:
            'a、Case Escalation Status \n' +
            'b、Parts Return Status \n' +
            'c、Root Cause Analysis Plan \n' +
            'd、Solution Measures \n' +
            'e、Activity Progress \n' +
            'f、Case Closure Status',
        historical_information: 'Historical Information',
        is_intensive_monitoring: 'Is intensive monitoring',
        partOrSoftwareNum: 'Part Number/Software Version',
        closeDate: 'Closure Time',
        original_content: 'Original Content',
        modified_time: 'Modified Time',
        modified_by: 'Modified By',
        exp_doc_details: 'Export Document Details',
        exp_report_data: 'Export Report Data',
    },
    // 德
    deDE: {
        customs_declaration_unit: 'Zolldeklarationseinheit',
        theme: 'Thema',
        model: 'Modell',
        problem_state: 'Problemzustand',
        TAC_submit_date: 'TAC-Einreichungsdatum',
        level: 'Ebene',
        type: 'Typ',
        vehicle_involved: 'An Tätigkeiten beteiligt',
        activity_code: 'Aktivitätscode',
        activity_name: 'Aktivitätsname',
        connected_activities: 'verbundene Aktivitäten',
        connected_activities_remarks: 'Beschreibung der verwandten Aktivität',
        system_problems: 'Systemprobleme',
        quantity: 'Menge',
        engine_type: 'Motortyp',
        gearbox_type: 'Getriebetyp',
        reporting_country: 'Berichterstattendes Land',
        region: 'Meldegebiet',
        date_of_feedback_to_QA: 'Datum der Rückmeldung an QA',
        required_part_return_date: 'Erforderliches Rücksendedatum des Teils',
        date_of_parts_delivery_to_QA: 'Datum der Auslieferung an QA',
        solution_release_date: 'Lösungsveröffentlichungsdatum',
        solution_target_date: 'Zieldatum für Lösung',
        end_date: 'Enddatum',
        difference: 'Unterschied',
        QA_weekday: 'QA-Wochentag',
        fault_description: 'Fehlerbeschreibung',
        root_cause: 'Grundursache',
        production_line_measures_Breakpoint:
            'Maßnahmen in der Produktionslinie/Unterbrechungspunkt',
        breakpoint: 'Maßnahmen nach dem Verkauf/Unterbrechungspunkt',
        process: 'Prozess',
        technical_document_attachments: 'Anlagen technischer Dokumente',
        connected_activities_required: 'Bitte wählen Sie eine zugehörige Aktivität aus',
        fault_desc_placeholder:
            'a. Straßenverhältnisse, Fahrbedingungen, Kundenbedienung, Instrumentenanzeigen, Fahrzeugleistung. \n' +
            'b. Prüfprozess, Wiederholung von Fehlern, Austausch und Ergebnisse, Fahrzeugreparaturstatus, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Produktionslinienverbesserungsplan && Produktionslinien-/Teileunterbrechungsinformationen',
        breakpoint_placeholder:
            'Kundendienstwartungsplan,Zeitpunkt der Freigabe des Kundendienstplans',
        process_placeholder:
            'a、Fallsteigerungsstatus \n' +
            'b、Status der Teile-Rücksendung \n' +
            'c、Plan für die Ursachenanalyse \n' +
            'd、Lösungsmaßnahmen \n' +
            'e、Aktivitätsfortschritt \n' +
            'f、Fallabschlussstatus',
        historical_information: 'Historische Informationen',
        is_intensive_monitoring: 'Wird es genau überwacht',
        partOrSoftwareNum: 'Teilenummer/Softwareversion',
        closeDate: 'Abschlusszeit',
        original_content: 'Ursprünglicher Inhalt',
        modified_time: 'Änderungszeit',
        modified_by: 'Geändert von',
        exp_doc_details: 'Belegdetails exportieren',
        exp_report_data: 'Berichtsdaten exportieren',
    },
    // 法
    frFR: {
        customs_declaration_unit: 'Unité de déclaration en douane',
        theme: 'Thème',
        model: 'Modèle',
        problem_state: 'État du problème',
        TAC_submit_date: 'Date de soumission TAC',
        level: 'Niveau',
        type: 'Type',
        vehicle_involved: 'Impliquant des activités',
        activity_code: 'Code d\'activité',
        activity_name: 'Nom de l\'activité',
        connected_activities: 'Activités associées',
        connected_activities_remarks: 'Description des activités associées',
        system_problems: 'Problèmes système',
        quantity: 'Quantité',
        engine_type: 'Type de moteur',
        gearbox_type: 'Type de boîte de vitesses',
        reporting_country: 'Pays déclarant',
        region: 'Région de déclaration',
        date_of_feedback_to_QA: 'Date de rétroaction à QA',
        required_part_return_date: 'Date de retour de pièce requise',
        date_of_parts_delivery_to_QA: 'Pièces livrées à la date QA',
        solution_release_date: 'Date de publication de la solution',
        solution_target_date: 'Date cible de la solution',
        end_date: 'Date de fin',
        difference: 'Différence',
        QA_weekday: 'Jour de la semaine QA',
        fault_description: 'Description de la faute',
        root_cause: 'Cause fondamentale',
        production_line_measures_Breakpoint: 'Mesures de la ligne de production/Point d\'arrêt',
        breakpoint: 'Mesures après-vente/Point d\'arrêt',
        process: 'Processus',
        technical_document_attachments: 'Pièces jointes de document technique',
        connected_activities_required: 'Veuillez sélectionner une activité associée',
        fault_desc_placeholder:
            'a. Conditions routières, Conditions de conduite, Opérations client, Indications du tableau de bord, Performance du véhicule. \n' +
            'b. Processus d\'inspection, Reproduction des pannes, Échange et résultats, État de réparation du véhicule, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Plan d\'amélioration de la ligne de production && Informations sur le point de rupture de la ligne de production/partie',
        breakpoint_placeholder:
            'Plan de maintenance après-vente,Heure de libération du plan après-vente',
        process_placeholder:
            'a、État de l\'escalade des cas \n' +
            'b、État des retours de pièces \n' +
            'c、Plan d\'analyse des causes \n' +
            'd、Mesures de solution \n' +
            'e、Progrès des activités \n' +
            'f、État de clôture des cas',
        historical_information: 'Informations historiques',
        is_intensive_monitoring: 'Est-ce suivi de près',
        partOrSoftwareNum: 'Numéro de pièce/Version du logiciel',
        closeDate: 'Temps de fermeture',
        original_content: 'Contenu d\'origine',
        modified_time: 'Temps de modification',
        modified_by: 'Modifié par',
        exp_doc_details: 'Exporter les détails du document',
        exp_report_data: 'Exporter les données du rapport',
    },
    // 意大利
    itIT: {
        customs_declaration_unit: 'Unità dichiarazione doganale',
        theme: 'Tema',
        model: 'Modello',
        problem_state: 'Stato del problema',
        TAC_submit_date: 'Data di invio TAC',
        level: 'Livello',
        type: 'Tipo',
        vehicle_involved: 'Coinvolto in attività',
        activity_code: 'Codice attività',
        activity_name: 'Nome attività',
        connected_activities: 'Attività correlate',
        connected_activities_remarks: 'Descrizione delle attività correlate',
        system_problems: 'Problemi di sistema',
        quantity: 'Quantità',
        engine_type: 'Tipo di motore',
        gearbox_type: 'Tipo di cambio',
        reporting_country: 'Paese dichiarante',
        region: 'Regione di segnalazione',
        date_of_feedback_to_QA: 'Data di feedback a QA',
        required_part_return_date: 'Data di restituzione della parte richiesta',
        date_of_parts_delivery_to_QA: 'Data di selezione della consegna a QA',
        solution_release_date: 'Data di rilascio della soluzione',
        solution_target_date: 'Data prevista per la soluzione',
        end_date: 'Data di fine',
        difference: 'Differenza',
        QA_weekday: 'Giorno lavorativo QA',
        fault_description: 'Descrizione del difetto',
        root_cause: 'Causa radicale',
        production_line_measures_Breakpoint:
            'Misure della linea di produzione/Punto di interruzione',
        breakpoint: 'Misure post-vendita/Punto di interruzione',
        process: 'Processo',
        technical_document_attachments: 'Allegati documento tecnico',
        connected_activities_required: 'Seleziona un\'attività associata',
        fault_desc_placeholder:
            'a. Condizioni stradali, Condizioni di guida, Operazioni del cliente, Promemoria strumenti, Prestazioni del veicolo. \n' +
            'b. Processo di ispezione, Riproduzione dei guasti, Scambio e risultati, Stato di riparazione del veicolo, ecc.',
        production_line_measures_Breakpoint_placeholder:
            'production_line_measures_Breakpoint_placeholder && Informazioni sul punto di interruzione della linea di produzione/parti',
        breakpoint_placeholder:
            'Piano di manutenzione post-vendita,Ora di rilascio del piano post-vendita',
        process_placeholder:
            'a、Stato dell\'escalation del caso \n' +
            'b、Stato del ritorno delle parti \n' +
            'c、Piano di analisi delle cause \n' +
            'd、Misure di soluzione \n' +
            'e、Progresso delle attività \n' +
            'f、Stato della chiusura del caso',
        historical_information: 'Informazioni storiche',
        is_intensive_monitoring: 'Viene monitorato attentamente',
        partOrSoftwareNum: 'Numero di parte/Versione del software',
        closeDate: 'Orario di chiusura',
        original_content: 'Contenuto originale',
        modified_time: 'Orario di modifica',
        modified_by: 'Modificato da',
        exp_doc_details: 'Esporta dettagli documento',
        exp_report_data: 'Esporta dati del rapporto',
    },
    // 荷兰
    nlNL: {
        customs_declaration_unit: 'Douane-aangifte-eenheid',
        theme: 'Thema',
        model: 'Model',
        problem_state: 'Probleemstatus',
        TAC_submit_date: 'TAC indieningsdatum',
        level: 'Niveau',
        type: 'Type',
        vehicle_involved: 'Betrokken bij activiteiten',
        activity_code: 'Activiteitencode',
        activity_name: 'Activiteitsnaam',
        connected_activities: 'Aanhangende activiteiten',
        connected_activities_remarks: 'Beschrijving verwante activiteit',
        system_problems: 'Systeemproblemen',
        quantity: 'Hoeveelheid',
        engine_type: 'Motortype',
        gearbox_type: 'Versnellingsbaktype',
        reporting_country: 'Rapporterend land',
        region: 'Rapporteringsregio',
        date_of_feedback_to_QA: 'Datum van feedback aan QA',
        required_part_return_date: 'Datum vereiste onderdeelretourzending',
        date_of_parts_delivery_to_QA: 'Datum van levering van onderdelen aan QA',
        solution_release_date: 'Oplossing vrijgavedatum',
        solution_target_date: 'Oplossingsdoelstelling datum',
        end_date: 'Einddatum',
        difference: 'Verschil',
        QA_weekday: 'QA weekdag',
        fault_description: 'Foutomschrijving',
        root_cause: 'Kernoorzaak',
        production_line_measures_Breakpoint: 'Maatregelen in de productielijn/Breekpunt',
        breakpoint: 'Maatregelen na verkoop/Breekpunt',
        process: 'Proces',
        technical_document_attachments: 'Technische documentbijlagen',
        connected_activities_required: 'Selecteer een bijbehorende activiteit',
        fault_desc_placeholder:
            'a. Wegomstandigheden, Rijomstandigheden, Klantbediening, Instrumentaanwijzingen, Voertuigprestaties. \n' +
            'b. Inspectieproces, Reproductie van fouten, Uitwisseling en resultaten, Voertuigherstelsituatie, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Productielijnverbeteringsplan && Productielijn-/Onderdeelonderbrekingsinformatie',
        breakpoint_placeholder: 'Nazorg Onderhoudsplan,Vrijgavetijd van nazorgplan',
        process_placeholder:
            'a、Status van de casusescalatie \n' +
            'b、Status van onderdelenretour \n' +
            'c、Plan voor root cause-analyse \n' +
            'd、Oplossingsmaatregelen \n' +
            'e、Voortgang van activiteiten \n' +
            'f、Status van de casusafsluiting',
        historical_information: 'Historische informatie',
        is_intensive_monitoring: 'Wordt het nauwlettend gevolgd',
        partOrSoftwareNum: 'Onderdeelnummer/Softwareversie',
        closeDate: 'Sluitingstijd',
        original_content: 'Oorspronkelijke inhoud',
        modified_time: 'Wijzigingstijd',
        modified_by: 'Gewijzigd door',
        exp_doc_details: 'Documentgegevens exporteren',
        exp_report_data: 'Rapportgegevens exporteren',
    },
    // 越南
    viVN: {
        customs_declaration_unit: 'Đơn vị khai báo hải quan',
        theme: 'Chủ đề',
        model: 'Mô hình',
        problem_state: 'Trạng thái vấn đề',
        TAC_submit_date: 'Ngày nộp TAC',
        level: 'Cấp độ',
        type: 'Loại',
        vehicle_involved: 'Hoạt động liên quan',
        activity_code: 'Mã hoạt động',
        activity_name: 'Tên hoạt động',
        connected_activities: 'Hoạt động liên quan',
        connected_activities_remarks: 'Mô tả hoạt động liên kết',
        system_problems: 'Vấn đề hệ thống',
        quantity: 'Số lượng',
        engine_type: 'Loại động cơ',
        gearbox_type: 'Loại hộp số',
        reporting_country: 'Quốc gia báo cáo',
        region: 'Vùng báo cáo',
        date_of_feedback_to_QA: 'Ngày phản hồi cho QA',
        required_part_return_date: 'Ngày yêu cầu trả linh kiện',
        date_of_parts_delivery_to_QA: 'Ngày giao linh kiện cho QA',
        solution_release_date: 'Ngày phát hành giải pháp',
        solution_target_date: 'Ngày mục tiêu giải pháp',
        end_date: 'Ngày kết thúc',
        difference: 'Sự khác biệt',
        QA_weekday: 'Ngày làm việc của QA',
        fault_description: 'Miêu tả lỗi',
        root_cause: 'Nguyên nhân cơ bản',
        production_line_measures_Breakpoint: 'Biện pháp trên dây chuyền sản xuất/Điểm ngắt',
        breakpoint: 'Biện pháp sau bán hàng/Điểm ngắt',
        process: 'Tiến trình mới nhất',
        technical_document_attachments: 'Tài liệu kỹ thuật đính kèm',
        connected_activities_required: 'Vui lòng chọn hoạt động liên kết',
        fault_desc_placeholder:
            'a. Điều kiện đường, Điều kiện lái xe, Thao tác của khách hàng, Hướng dẫn bảng đồng hồ, Hiệu suất của xe. \n' +
            'b. Quy trình kiểm tra, Tái tạo lỗi, Trao đổi và kết quả, Tình trạng sửa chữa xe, vv.',
        production_line_measures_Breakpoint_placeholder:
            'Kế hoạch cải thiện dây chuyền sản xuất && Thông tin về điểm ngắt dây chuyền sản xuất/Phần',
        breakpoint_placeholder:
            'Kế hoạch bảo dưỡng sau bán hàng,Thời gian phát hành kế hoạch sau bán hàng',
        process_placeholder:
            'a、Tình trạng nâng cao vụ án \n' +
            'b、Tình trạng trả lại linh kiện \n' +
            'c、Kế hoạch phân tích nguyên nhân \n' +
            'd、Biện pháp giải quyết \n' +
            'e、Tiến triển của hoạt động \n' +
            'f、Tình trạng đóng vụ án',
        historical_information: 'Thông tin lịch sử',
        is_intensive_monitoring: 'Có đang được theo dõi chặt chẽ không',
        partOrSoftwareNum: 'Số phần/Phiên bản phần mềm',
        closeDate: 'Thời gian đóng cửa',
        original_content: 'Nội dung gốc',
        modified_time: 'Thời gian sửa đổi',
        modified_by: 'Người sửa đổi',
        exp_doc_details: 'Xuất chi tiết chứng từ',
        exp_report_data: 'Xuất dữ liệu báo cáo',
    },
    // 西班牙
    esES: {
        customs_declaration_unit: 'Agente de despacho de aduana',
        theme: 'Tema',
        model: 'Modelo',
        problem_state: 'Estado del Problema',
        TAC_submit_date: 'Fecha de envío a TAC',
        level: 'Nivel',
        type: 'Tipo',
        vehicle_involved: 'Actividades relacionadas',
        activity_code: 'Código de actividad',
        activity_name: 'Nombre de actividad',
        connected_activities: 'Actividad relacionada',
        connected_activities_remarks: 'Descripción de las actividades relacionadas',
        system_problems: 'Problema de sistema',
        quantity: 'Cantidad',
        engine_type: 'Tipo de motor',
        gearbox_type: 'Tipo de caja de cambios',
        reporting_country: 'País informante',
        region: 'Región de informe',
        date_of_feedback_to_QA: 'Fecha de retroalimentación a QA',
        required_part_return_date: 'Fecha de devolución de piezas requeridas',
        date_of_parts_delivery_to_QA: 'Fecha de entrega de piezas a QA',
        solution_release_date: 'Fecha de publicación de la solución',
        solution_target_date: 'Fecha objetivo de la solución',
        end_date: 'Fecha de finalización',
        difference: 'Diferencia',
        QA_weekday: 'Días laborables de QA',
        fault_description: 'Descripción de la falla',
        root_cause: 'Causa raíz',
        production_line_measures_Breakpoint:
            'Medidas en la línea de producción/Punto de interrupción',
        breakpoint: 'Medidas postventa/Punto de interrupción',
        process: 'Últimos avances',
        technical_document_attachments: 'Adjunto de documento técnico',
        connected_activities_required: 'Por favor, seleccione la actividad asociada',
        fault_desc_placeholder:
            'a. Condiciones de la carretera, Condiciones de conducción, Operaciones del cliente, Indicaciones del panel de instrumentos, Rendimiento del vehículo. \n' +
            'b. Proceso de inspección, Reproducción de fallas, Intercambio y resultados, Estado de reparación del vehículo, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Plan de mejora de la línea de producción &&  Información de punto de ruptura de línea de producción/parte',
        breakpoint_placeholder:
            'Plan de mantenimiento postventa,Hora de liberación del plan postventa',
        process_placeholder:
            'a、Estado de escalada del caso \n' +
            'b、Estado de devolución de piezas \n' +
            'c、Plan de análisis de causas \n' +
            'd、Medidas de solución \n' +
            'e、Progreso de actividades \n' +
            'f、Estado de cierre del caso',
        historical_information: 'Información histórica',
        is_intensive_monitoring: '¿Se está siguiendo de cerca',
        partOrSoftwareNum: 'Número de pieza/Versión de software',
        closeDate: 'Hora de cierre',
        original_content: 'Contenido original',
        modified_time: 'Hora de modificación',
        modified_by: 'Modificado por',
        exp_doc_details: 'Exportar detalles del documento',
        exp_report_data: 'Exportar datos del informe',
    },
    // 葡萄牙
    ptBR: {
        customs_declaration_unit: 'Unidade de declaração aduaneira',
        theme: 'Tema',
        model: 'Modelo',
        problem_state: 'Estado do problema',
        TAC_submit_date: 'Data de envio do TAC',
        level: 'Nível',
        type: 'Tipo',
        vehicle_involved: 'Atividades envolvidas',
        activity_code: 'Código de atividade',
        activity_name: 'Nome da atividade',
        connected_activities: 'Atividades conectadas',
        connected_activities_remarks: 'Observações das atividades conectadas',
        system_problems: 'Problemas do sistema',
        quantity: 'Quantidade',
        engine_type: 'Tipo de motor',
        gearbox_type: 'Tipo de caixa de câmbio',
        reporting_country: 'País de relato',
        region: 'Região de relatório',
        date_of_feedback_to_QA: 'Data de feedback para QA',
        required_part_return_date: 'Data de devolução da peça requerida',
        date_of_parts_delivery_to_QA: 'Data de entrega das peças para QA',
        solution_release_date: 'Data de lançamento da solução',
        solution_target_date: 'Data de conclusão desejada da solução',
        end_date: 'Data de término',
        difference: 'Diferença',
        QA_weekday: 'Dias úteis do QA',
        fault_description: 'Descrição da falha',
        root_cause: 'Causa raiz',
        production_line_measures_Breakpoint: 'Medidas na linha de produção/Ponto de interrupção',
        breakpoint: 'Medidas pós-venda/Ponto de interrupção',
        process: 'Últimas etapas',
        technical_document_attachments: 'Anexos de documentos técnicos',
        connected_activities_required: 'Por favor, selecione atividades conectadas',
        fault_desc_placeholder:
            'a. Condições da estrada, Condições de condução, Operações do cliente, Indicações do painel de instrumentos, Desempenho do veículo. \n' +
            'b. Processo de inspeção, Reprodução de falhas, Troca e resultados, Estado de reparo do veículo, etc.',
        production_line_measures_Breakpoint_placeholder:
            'Plano de Melhoria da Linha de Produção && Informações de ponto de interrupção da linha de produção/peça',
        breakpoint_placeholder:
            'Plano de Manutenção Pós-Venda,Hora de liberação do plano pós-venda',
        process_placeholder:
            'a、Estado de escalonamento de casos \n' +
            'b、Estado de retorno de peças \n' +
            'c、Plano de análise de causas \n' +
            'd、Medidas de solução \n' +
            'e、Progresso das atividades \n' +
            'f、Estado de encerramento do caso',
        historical_information: 'Informações históricas',
        is_intensive_monitoring: 'Está sendo monitorado de perto',
        partOrSoftwareNum: 'Número da peça/Versão do software',
        closeDate: 'Hora de fechamento',
        original_content: 'Conteúdo original',
        modified_time: 'Tempo de modificação',
        modified_by: 'Modificado por',
        exp_doc_details: 'Exportar detalhes do documento',
        exp_report_data: 'Exportar dados do relatório',
    },
    // 波兰
    plPL: {
        customs_declaration_unit: 'Jednostka zgłoszenia celnego',
        theme: 'Temat',
        model: 'Model',
        problem_state: 'Status sprawy',
        TAC_submit_date: 'Data zgłoszenia',
        level: 'Poziom',
        type: 'Rodzaj',
        vehicle_involved: 'Zaangażowany w działania',
        activity_code: 'Kod działania',
        activity_name: 'Nazwa działania',
        connected_activities: 'Działania powiązane',
        connected_activities_remarks: 'Uwagi dotyczące powiązanych aktywności',
        system_problems: 'Błąd systemu',
        quantity: 'Ilość',
        engine_type: 'Typ silnika',
        gearbox_type: 'Typ skrzyni biegów',
        reporting_country: 'Kraj raportujący',
        region: 'Region raportowania',
        date_of_feedback_to_QA: 'Data przekazania informacji zwrotnej',
        required_part_return_date: 'Data zwrotu potrzebnej częsci',
        date_of_parts_delivery_to_QA: 'Data dostarczenia części',
        solution_release_date: 'Data wydania rozwiązania',
        solution_target_date: 'Docelowa data rozwiązania sprawy',
        end_date: 'Data zakończenia',
        difference: 'Różnica',
        QA_weekday: 'Dni pracy',
        fault_description: 'Opis błędu',
        root_cause: 'Przyczyna podstawowa',
        production_line_measures_Breakpoint: 'Środki na linii produkcyjnej/Punkt przerwania',
        breakpoint: 'Środki posprzedażowe/Punkt przerwania',
        process: 'Postęp',
        technical_document_attachments: 'Załączone dokumenty techniczne',
        connected_activities_required: 'Proszę wybrać powiązane aktywności',
        fault_desc_placeholder:
            'a. Warunki drogowe, Warunki jazdy, Obsługa klienta, Wskazówki deski rozdzielczej, Wydajność pojazdu. \n' +
            'b. Proces inspekcji, Reprodukcja usterek, Wymiana i wyniki, Stan naprawy pojazdu, itp.',
        production_line_measures_Breakpoint_placeholder:
            'Plan poprawy linii produkcyjnej && Informacje o punkcie przerwania linii produkcyjnej/części',
        breakpoint_placeholder:
            'Plan konserwacji posprzedażowej,Czas wydania planu posprzedażowego',
        process_placeholder:
            'a、Status eskalacji przypadku \n' +
            'b、Status zwrotu części \n' +
            'c、Plan analizy przyczyn \n' +
            'd、Środki rozwiązania \n' +
            'e、Postęp w działaniach \n' +
            'f、Status zamknięcia przypadku',
        historical_information: 'Informacje historyczne',
        is_intensive_monitoring: 'Czy jest śledzone dokładnie',
        partOrSoftwareNum: 'Numer części/Wersja oprogramowania',
        closeDate: 'Czas zamknięcia',
        original_content: 'Oryginalna zawartość',
        modified_time: 'Czas modyfikacji',
        modified_by: 'Zmodyfikowane przez',
        exp_doc_details: 'Eksportuj szczegóły dokumentu',
        exp_report_data: 'Eksportuj dane raportu',
    },
    // 土耳其
    trTR: {
        customs_declaration_unit: 'Özel deklarasyon birimi',
        theme: 'Tema',
        model: 'Model',
        problem_state: 'Sorun durumu',
        TAC_submit_date: 'TAC dağıt',
        level: 'Seviye',
        type: 'Türü',
        vehicle_involved: 'Etkinliğe dahil edildi',
        activity_code: 'Etkinlik kodu',
        activity_name: 'Etkinlik adı',
        connected_activities: 'Bağlanmış etkinlikler',
        connected_activities_remarks: 'Bağlantı etkinlik açıklayın',
        system_problems: 'Sistem sorunları',
        quantity: 'Adet',
        engine_type: 'Motor tipi',
        gearbox_type: 'Gearbox tipi',
        reporting_country: 'Bildiren ülke',
        region: 'Bildirilen Bölge',
        date_of_feedback_to_QA: 'QA\'ye geri dönüş tarihi',
        required_part_return_date: 'Gerekli parça dönüş tarihi',
        date_of_parts_delivery_to_QA: 'QA\'ye teslim edilmesi tarihic',
        solution_release_date: 'Çözümün yayınlama tarihi',
        solution_target_date: 'Çözüm hedef tarihi',
        end_date: 'Bitiş tarihi',
        difference: 'Farklılık',
        QA_weekday: 'QA çalışma günü',
        fault_description: 'Hata tanımı',
        root_cause: 'Temel Neden',
        production_line_measures_Breakpoint: 'Üretim hattındaki önlemler/Kesme noktası',
        breakpoint: 'Satış Sonrası Önlemler/Kesme Noktası',
        process: 'İşlem',
        technical_document_attachments: 'Tehnik belge ekleri',
        connected_activities_required: 'seçenek İlişkili etkinlikler',
        fault_desc_placeholder:
            'a. Yol koşulları, Sürüş koşulları, Müşteri operasyonları, Gösterge tablosu uyarıları, Araç performansı. \n' +
            'b. İnceleme süreci, Arızaların tekrarı, Değişim ve sonuçlar, Araç tamir durumu, vb.',
        production_line_measures_Breakpoint_placeholder:
            'Üretim Hattı İyileştirme Planı && Üretim Hattı/Parça Kesme Noktası Bilgisi',
        breakpoint_placeholder:
            'Satış Sonrası Bakım Planı,Satış sonrası planın serbest bırakılma zamanı',
        process_placeholder:
            'a、Vaka Yükseltme Durumu \n' +
            'b、Parça İade Durumu \n' +
            'c、Kök Neden Analizi Planı \n' +
            'd、Çözüm Tedbirleri \n' +
            'e、Faaliyet İlerleme Durumu \n' +
            'f、Vaka Kapanış Durumu',
        historical_information: 'Tarihsel Bilgiler',
        is_intensive_monitoring: 'Yakından izleniyor mu',
        partOrSoftwareNum: 'Parça Numarası/Yazılım Sürümü',
        closeDate: 'Kapanış Zamanı',
        original_content: 'Orijinal İçerik',
        modified_time: 'Değiştirme Zamanı',
        modified_by: 'Tarafından değiştirildi',
        exp_doc_details: 'Belge Ayrıntılarını Dışa Aktar',
        exp_report_data: 'Rapor Verilerini Dışa Aktar',
    },
    // 捷克语
    csCZ: {
        customs_declaration_unit: 'Celní deklarační jednotka',
        theme: 'Téma',
        model: 'Model',
        problem_state: 'Stav problému',
        TAC_submit_date: 'Datum odeslání TAC',
        level: 'Úroveň',
        type: 'Typ',
        vehicle_involved: 'Podílí se na aktivitách',
        activity_code: 'Kód aktivity',
        activity_name: 'Název aktivity',
        connected_activities: 'Související aktivity',
        connected_activities_remarks: 'Popis souvisejících aktivit',
        system_problems: 'Systémové problémy',
        quantity: 'Množství',
        engine_type: 'Typ motoru',
        gearbox_type: 'Typ převodovky',
        reporting_country: 'Oznamující země',
        region: 'Oblast hlášení',
        date_of_feedback_to_QA: 'Datum zpětné vazby na QA',
        required_part_return_date: 'Požadované datum vrácení dílu',
        date_of_parts_delivery_to_QA: 'Datum vybraného doručení do QA',
        solution_release_date: 'Datum vydání řešení',
        solution_target_date: 'Cílové datum řešení',
        end_date: 'Datum ukončení',
        difference: 'Rozdíl',
        QA_weekday: 'Dotazy/odpovědi všední den',
        fault_description: 'Popis závady',
        root_cause: 'Příčina',
        production_line_measures_Breakpoint: 'Opatření na výrobní lince /Breakpoint',
        breakpoint: 'Poprodejní opatření /Breakpoint',
        process: 'Poslední pokrok',
        technical_document_attachments: 'Přílohy technických dokumentů',
        connected_activities_required: 'Vyberte přidruženou aktivitu',
        fault_desc_placeholder:
            '„a. Stav vozovky, Jízdní podmínky, jízdní styl zákazníka, informace na přístroji, Výkon vozidla. \nb. Postup kontroly, Reprodukce závad, Záměny a výsledky, Stav opravy vozidla atd..',
        production_line_measures_Breakpoint_placeholder:
            'Production Line Improvement Plan && Production Line/Part Breakpoint Information',
        breakpoint_placeholder: 'After-Sales Maintenance Plan , After-Sales Plan Release Time',
        process_placeholder:
            'a、Stav eskalace případu \n' +
            'b、Stav vrácení dílů \n' +
            'c、Plán analýzy hlavních příčin \n' +
            'd、Opatření při řešení \n' +
            'e、Pokrok v činnosti \n' +
            'f、Stav uzavření případu',
        historical_information: 'historické informace',
        is_intensive_monitoring: 'Je intenzivně sledováno',
        partOrSoftwareNum: 'Číslo dílu/verze softwaru',
        closeDate: 'Čas uzavření',
        original_content: 'Původní obsah',
        modified_time: 'Upravený čas',
        modified_by: 'Upraveno',
        exp_doc_details: 'Exportovat podrobnosti dokumentu',
        exp_report_data: 'Exportovat data sestavy',
    },
    // 匈牙利语
    huHU: {
        customs_declaration_unit: 'Vámkezelési egység',
        theme: 'Téma',
        model: 'Modell',
        problem_state: 'Probléma állapota',
        TAC_submit_date: 'TAC-beküldés dátuma',
        level: 'Szint',
        type: 'Típus',
        vehicle_involved: 'Részt vesz tevékenységekben',
        activity_code: 'Tevékenységkód',
        activity_name: 'Tevékenységnév',
        connected_activities: 'Kapcsolódó tevékenységek',
        connected_activities_remarks: 'Kapcsolódó tevékenységek leírása',
        system_problems: 'Rendszerproblémák',
        quantity: 'Mennyiség',
        engine_type: 'Motor típusa',
        gearbox_type: 'Váltómű típusa',
        reporting_country: 'Jelentő ország',
        region: 'Jelentő régió',
        date_of_feedback_to_QA: 'Visszajelzés dátuma MB felé',
        required_part_return_date: 'Szükséges alkatrész-visszaküldés dátuma',
        date_of_parts_delivery_to_QA: 'MB felé kiválasztott szállítmány dátuma',
        solution_release_date: 'Megoldás kiadási dátuma',
        solution_target_date: 'Megoldás céldátuma',
        end_date: 'Befejező dátum',
        difference: 'Eltérés',
        QA_weekday: 'MB hétköznap',
        fault_description: 'Hibaleírás',
        root_cause: 'Kiváltó ok',
        production_line_measures_Breakpoint: 'Gyártósori intézkedések/meghibásodás',
        breakpoint: 'Ügyfélszolgálati intézkedések/meghibásodás',
        process: 'Legutóbbi előrelépések',
        technical_document_attachments: 'Műszaki dokumentum mellékletek',
        connected_activities_required: 'Válasszon társított tevékenységet',
        fault_desc_placeholder:
            'a. Útviszonyok, menetkörülmények, ügyfél általi kezelés, műszerek jelzései, járműteljesítmény. \n' +
            'b. Átvizsgálási folyamat, hibák reprodukálása, csere és eredmények, járműjavítás helyzete stb.',
        production_line_measures_Breakpoint_placeholder:
            'Gyártósor-fejlesztési terv és gyártósor/alkatrész meghibásodási adatok',
        breakpoint_placeholder:
            'Ügyfélszolgálati karbantartási terv, ügyfélszolgálati terv kiadási ideje',
        process_placeholder:
            'a. Eset eszkalációs állapota \n' +
            'b. Alkatrész-visszaküldések állapota \n' +
            'c. Kiváltó okok elemzési terve \n' +
            'd. Megoldási intézkedések \n' +
            'e. Tevékenység előrehaladta \n' +
            'f. Esetlezárási állapot',
        historical_information: 'Előzményadatok',
        is_intensive_monitoring: 'Intenzív felügyeletre szorul-e',
        partOrSoftwareNum: 'Alkatrészszám/szoftververzió',
        closeDate: 'Lezárás ideje',
        original_content: 'Eredeti tartalom',
        modified_time: 'Módosítás ideje',
        modified_by: 'Módosította',
        exp_doc_details: 'Dokumentum részleteinek exportálása',
        exp_report_data: 'Jelentésadatok exportálása',
    },
    // 俄罗斯语
    ruRU: {
        customs_declaration_unit: 'Таможенная декларация',
        theme: 'Тема',
        model: 'Модель',
        problem_state: 'Состояние проблемы',
        TAC_submit_date: 'Дата подачи TAC',
        level: 'Уровень',
        type: 'Тип',
        vehicle_involved: 'Участвует в мероприятиях',
        activity_code: 'Код мероприятия',
        activity_name: 'Название мероприятия',
        connected_activities: 'Связанные мероприятия',
        connected_activities_remarks: 'Описание связанных мероприятий',
        system_problems: 'Проблемы системы',
        quantity: 'Количество',
        engine_type: 'Тип двигателя',
        gearbox_type: 'Тип трансмиссии',
        reporting_country: 'Страна отчета',
        region: 'Регион отчета',
        date_of_feedback_to_QA: 'Дата ответа QA',
        required_part_return_date: 'Дата возврата необходимых частей',
        date_of_parts_delivery_to_QA: 'Дата выбора доставки в QA',
        solution_release_date: 'Дата выпуска решения',
        solution_target_date: 'Целевая дата решения',
        end_date: 'Дата окончания',
        difference: 'Разница',
        QA_weekday: 'QA неделя',
        fault_description: 'Описание неисправности',
        root_cause: 'Коренная причина',
        production_line_measures_Breakpoint: 'Меры на производственной линии/Перерыв',
        breakpoint: 'Меры после продаж/Перерыв',
        process: 'Последний прогресс',
        technical_document_attachments: 'Вложения технических документов',
        connected_activities_required: 'Пожалуйста, выберите связанное мероприятие',
        fault_desc_placeholder:
            'a. Дорожные условия, Условия вождения, Операции клиента, Подсказки приборной панели, Производительность автомобиля и т.д. \n' +
            'b. Процесс инспекции, Воспроизведение неисправностей, Замена и результаты, Ситуация с ремонтом автомобиля и т.д.',
        production_line_measures_Breakpoint_placeholder:
            'План улучшения производственной линии && Информация о прерывании производственной линии/части',
        breakpoint_placeholder:
            'План обслуживания после продаж, Время выпуска плана обслуживания после продаж',
        process_placeholder:
            'a. Статус эскалации дела \n' +
            'b. Статус возврата частей \n' +
            'c. План анализа коренной причины \n' +
            'd. Меры по решению \ne. Прогресс мероприятия \n' +
            'f. Статус закрытия дела',
        historical_information: 'Историческая информация',
        is_intensive_monitoring: 'Является ли интенсивным мониторингом',
        partOrSoftwareNum: 'Номер детали/Версия программного обеспечения',
        closeDate: 'Время закрытия',
        original_content: 'Оригинальное содержание',
        modified_time: 'Время модификации',
        modified_by: 'Модифицировал',
        exp_doc_details: 'Экспорт деталей документа',
        exp_report_data: 'Экспорт данных отчета',
    },
    // 沙特阿拉伯
    arSA: {
        customs_declaration_unit: 'وحدة التخليص الجمركي',
        theme: 'الموضوع',
        model: 'الموديل',
        problem_state: 'حالة المشكلة',
        TAC_submit_date: 'تاريخ تقديم TAC',
        level: 'المستوى',
        type: 'النوع',
        vehicle_involved: 'النشاطات المعنية',
        activity_code: 'رمز النشاط',
        activity_name: 'اسم النشاط',
        connected_activities: 'الأنشطة المرتبطة',
        connected_activities_remarks: 'ملاحظات الأنشطة المرتبطة',
        system_problems: 'مشاكل النظام',
        quantity: 'الكمية',
        engine_type: 'نوع المحرك',
        gearbox_type: 'نوع علبة التروس',
        reporting_country: 'دولة الإبلاغ',
        region: 'منطقة الإبلاغ',
        date_of_feedback_to_QA: 'تاريخ التغذية المرتدة إلى QA',
        required_part_return_date: 'تاريخ طلب إرجاع القطعة',
        date_of_parts_delivery_to_QA: 'تاريخ تسليم القطع إلى QA',
        solution_release_date: 'تاريخ نشر الحل',
        solution_target_date: 'تاريخ الهدف للحل',
        end_date: 'تاريخ الانتهاء',
        difference: 'الفرق',
        QA_weekday: 'أيام عمل QA',
        fault_description: 'وصف العطل',
        root_cause: 'السبب الجذري',
        production_line_measures_Breakpoint: 'إجراءات خط الإنتاج/نقطة التوقف',
        breakpoint: 'إجراءات ما بعد البيع/نقطة التوقف',
        process: 'آخر التطورات',
        technical_document_attachments: 'مرفقات المستندات الفنية',
        connected_activities_required: 'يرجى اختيار نشاط مرتبط',
        fault_desc_placeholder:
            'أ. حالة الطريق، ظروف القيادة، تشغيل العميل، تنبيهات لوحة القيادة، أداء المركبة\n' +
            'ب. عملية الفحص، هل تم إعادة إنتاج العطل، النتائج بعد التبديل، حالة إصلاح المركبة، إلخ',
        production_line_measures_Breakpoint_placeholder:
            'خطة تحسين خط الإنتاج ومعلومات نقطة التوقف لخط الإنتاج/القطع',
        breakpoint_placeholder: 'خطة الصيانة بعد البيع، وقت إطلاق خطة ما بعد البيع',
        process_placeholder:
            'أ. تصعيد الحالة\n' +
            'ب. حالة إعادة شحن القطع\n' +
            'ج. خطة تحليل السبب\n' +
            'د. إجراءات الحل\n' +
            'هـ. حالة تنفيذ النشاط\n' +
            'و. حالة إغلاق الحالة، إلخ',
        historical_information: 'المعلومات التاريخية',
        is_intensive_monitoring: 'هل يتم تتبعها بشكل مكثف؟',
        partOrSoftwareNum: 'رقم القطعة/إصدار البرنامج',
        closeDate: 'وقت الإغلاق',
        original_content: 'المحتوى قبل التعديل',
        modified_time: 'وقت التعديل',
        modified_by: 'المعدّل',
        exp_doc_details: 'تصدير تفاصيل المستندات',
        exp_report_data: 'تصدير بيانات التقرير',
    },
    // 保加利亚
    bgBG: {
        customs_declaration_unit: 'Декларираща единица за митницата',
        theme: 'Тема',
        model: 'Модел',
        problem_state: 'Състояние на проблема',
        TAC_submit_date: 'Дата на подаване в TAC',
        level: 'Ниво',
        type: 'Тип',
        vehicle_involved: 'Свързани дейности',
        activity_code: 'Код на дейността',
        activity_name: 'Име на дейността',
        connected_activities: 'Свързани дейности',
        connected_activities_remarks: 'Бележки към свързаните дейности',
        system_problems: 'Проблеми със системата',
        quantity: 'Количество',
        engine_type: 'Тип двигател',
        gearbox_type: 'Тип скоростна кутия',
        reporting_country: 'Държава на докладване',
        region: 'Регион на докладване',
        date_of_feedback_to_QA: 'Дата на обратна връзка към QA',
        required_part_return_date: 'Изисквана дата за връщане на частта',
        date_of_parts_delivery_to_QA: 'Дата на доставка на частите до QA',
        solution_release_date: 'Дата на публикуване на решението',
        solution_target_date: 'Целева дата за решението',
        end_date: 'Крайна дата',
        difference: 'Разлика',
        QA_weekday: 'Работни дни на QA',
        fault_description: 'Описание на неизправността',
        root_cause: 'Основна причина',
        production_line_measures_Breakpoint:
            'Мерки по производствената линия / точка на прекъсване',
        breakpoint: 'Мерки след продажба / точка на прекъсване',
        process: 'Последен напредък',
        technical_document_attachments: 'Прикачени технически документи',
        connected_activities_required: 'Моля, изберете свързана дейност',
        fault_desc_placeholder:
            'а. Състояние на пътя, условия на шофиране, действия на клиента, индикации от таблото, поведение на превозното средство\n' +
            'б. Процес на проверка, дали неизправността е възпроизведена, резултати от размяна и състояние на ремонта на превозното средство и др.',
        production_line_measures_Breakpoint_placeholder:
            'План за подобрение на производствената линия и информация за точката на прекъсване на линията/частите',
        breakpoint_placeholder:
            'План за сервизно обслужване след продажба, време на пускане на плана след продажба',
        process_placeholder:
            'а. Повишаване на случая\n' +
            'б. Състояние на връщане на части\n' +
            'в. План за анализ на причините\n' +
            'г. Мерки за решение\n' +
            'д. Състояние на провеждане на активността\n' +
            'е. Състояние на затваряне на случая и др.',
        historical_information: 'Историческа информация',
        is_intensive_monitoring: 'Подлежи ли на интензивно наблюдение?',
        partOrSoftwareNum: 'Номер на част / версия на софтуера',
        closeDate: 'Време на затваряне',
        original_content: 'Съдържание преди промяната',
        modified_time: 'Време на промяна',
        modified_by: 'Променено от',
        exp_doc_details: 'Експорт на детайли на документите',
        exp_report_data: 'Експорт на данни от отчета',
    },
    // 丹麦语
    daDK: {
        customs_declaration_unit: 'Toldangivelsesenhed',
        theme: 'Tema',
        model: 'Model',
        problem_state: 'Problemstatus',
        TAC_submit_date: 'TAC-indsendelsesdato',
        level: 'Niveau',
        type: 'Type',
        vehicle_involved: 'Relaterede aktiviteter',
        activity_code: 'Aktivitetskode',
        activity_name: 'Aktivitetsnavn',
        connected_activities: 'Forbundne aktiviteter',
        connected_activities_remarks: 'Bemærkninger til forbundne aktiviteter',
        system_problems: 'Systemproblemer',
        quantity: 'Antal',
        engine_type: 'Motortype',
        gearbox_type: 'Gearkassetype',
        reporting_country: 'Rapporterende land',
        region: 'Rapporterende region',
        date_of_feedback_to_QA: 'Dato for feedback til QA',
        required_part_return_date: 'Påkrævet returdato for komponent',
        date_of_parts_delivery_to_QA: 'Dato for levering af dele til QA',
        solution_release_date: 'Løsningsudgivelsesdato',
        solution_target_date: 'Måldato for løsning',
        end_date: 'Slutdato',
        difference: 'Forskel',
        QA_weekday: 'QA-arbejdsdage',
        fault_description: 'Fejlbeskrivelse',
        root_cause: 'Grundårsag',
        production_line_measures_Breakpoint: 'Produktionslinjetiltag / breakpoint',
        breakpoint: 'Eftersalgstiltag / breakpoint',
        process: 'Seneste fremskridt',
        technical_document_attachments: 'Vedhæftede tekniske dokumenter',
        connected_activities_required: 'Vælg venligst en forbunden aktivitet',
        fault_desc_placeholder:
            'a. Vejforhold, køreforhold, kundebrug, instrumentindikationer, køretøjens ydeevne\n' +
            'b. Inspektionsproces, om fejlen kunne genskabes, udskiftning og resultater, reparation af køretøjet osv.',
        production_line_measures_Breakpoint_placeholder:
            'Forbedringsplan for produktionslinje og breakpoint-information for linje/komponenter',
        breakpoint_placeholder:
            'Eftersalgsserviceløsning, tidspunkt for frigivelse af eftersalgsplan',
        process_placeholder:
            'a. Sagseskalering\n' +
            'b. Tilstand for returnering af dele\n' +
            'c. Plan for årsagsanalyse\n' +
            'd. Løsningsforanstaltninger\n' +
            'e. Aktivitetsstatus\n' +
            'f. Status for sagsslutning osv.',
        historical_information: 'Historisk information',
        is_intensive_monitoring: 'Skal det følges tæt?',
        partOrSoftwareNum: 'Delnummer / softwareversion',
        closeDate: 'Lukketidspunkt',
        original_content: 'Indhold før ændring',
        modified_time: 'Ændringstidspunkt',
        modified_by: 'Ændret af',
        exp_doc_details: 'Eksportér dokumentdetaljer',
        exp_report_data: 'Eksportér rapportdata',
    },
    // 芬兰语
    fiFI: {
        customs_declaration_unit: 'Tulli-ilmoitusyksikkö',
        theme: 'Teema',
        model: 'Malli',
        problem_state: 'Ongelman tila',
        TAC_submit_date: 'TAC-lähetyksen päivämäärä',
        level: 'Taso',
        type: 'Tyyppi',
        vehicle_involved: 'Liittyvät toiminnot',
        activity_code: 'Toimintakoodi',
        activity_name: 'Toiminnan nimi',
        connected_activities: 'Liittyvät toiminnot',
        connected_activities_remarks: 'Huomautukset liittyvistä toiminnoista',
        system_problems: 'Järjestelmäongelmat',
        quantity: 'Määrä',
        engine_type: 'Moottorityyppi',
        gearbox_type: 'Vaihteisto tyyppi',
        reporting_country: 'Ilmoittava maa',
        region: 'Ilmoittava alue',
        date_of_feedback_to_QA: 'Palautteen antamispäivä QA:lle',
        required_part_return_date: 'Vaadittu varaosan palautuspäivä',
        date_of_parts_delivery_to_QA: 'Varaosien toimituspäivä QA:lle',
        solution_release_date: 'Ratkaisun julkaisupäivä',
        solution_target_date: 'Ratkaisun tavoitepäivä',
        end_date: 'Päättymispäivä',
        difference: 'Ero',
        QA_weekday: 'QA-työpäivät',
        fault_description: 'Vian kuvaus',
        root_cause: 'Juurisyy',
        production_line_measures_Breakpoint: 'Tuotantolinjan toimenpiteet/katkaisupiste',
        breakpoint: 'Jälkimarkkinointitoimenpiteet/katkaisupiste',
        process: 'Viimeisimmät edistymiset',
        technical_document_attachments: 'Teknisten asiakirjojen liitteet',
        connected_activities_required: 'Valitse liittyvä toiminta',
        fault_desc_placeholder:
            'a. Tieolosuhteet, ajotilanne, asiakkaan toimet, kojelaudan varoitukset, ajoneuvon käyttäytyminen\n' +
            'b. Tarkastusprosessi, onko vika toistettavissa, vaihto ja sen tulokset, ajoneuvon korjaustilanne jne.',
        production_line_measures_Breakpoint_placeholder:
            'Tuotantolinjan parannussuunnitelma ja linjan/osien katkaisupisteen tiedot',
        breakpoint_placeholder:
            'Jälkimarkkinointikorjaussuunnitelma, jälkimarkkinointisuunnitelman julkaistuaika',
        process_placeholder:
            'a. Tapauksen eskalaatio\n' +
            'b. Osien palautustilanne\n' +
            'c. Syyanalyysisuunnitelma\n' +
            'd. Korjaustoimenpiteet\n' +
            'e. Toiminnan toteutustilanne\n' +
            'f. Tapauksen sulkutilanne jne.',
        historical_information: 'Historiallinen tieto',
        is_intensive_monitoring: 'Seurataanko erityisen tiiviisti?',
        partOrSoftwareNum: 'Osanumero / ohjelmistoversio',
        closeDate: 'Sulkemisaika',
        original_content: 'Sisältö ennen muokkausta',
        modified_time: 'Muokkausaika',
        modified_by: 'Muokannut',
        exp_doc_details: 'Asiakirjatietojen vienti',
        exp_report_data: 'Raporttitietojen vienti',
    },
    // 繁体中文台湾
    zhTW: {
        customs_declaration_unit: '報關單位',
        theme: '主題',
        model: '型號',
        problem_state: '問題狀態',
        TAC_submit_date: 'TAC提交日期',
        level: '級別',
        type: '類型',
        vehicle_involved: '涉及活動',
        activity_code: '活動代碼',
        activity_name: '活動名稱',
        connected_activities: '關聯活動',
        connected_activities_remarks: '關聯活動說明',
        system_problems: '系統問題',
        quantity: '數量',
        engine_type: '引擎類型',
        gearbox_type: '變速箱類型',
        reporting_country: '上報國家',
        region: '上報地區',
        date_of_feedback_to_QA: '回饋到QA日期',
        required_part_return_date: '要求零件返回日期',
        date_of_parts_delivery_to_QA: '零件交付到QA日期',
        solution_release_date: '解決方案發布日期',
        solution_target_date: '解決方案目標日期',
        end_date: '結束日期',
        difference: '差異',
        QA_weekday: 'QA工作日',
        fault_description: '故障描述',
        root_cause: '根本原因',
        production_line_measures_Breakpoint: '產線措施／斷點',
        breakpoint: '售後措施／斷點',
        process: '最新進展',
        technical_document_attachments: '技術文件附件',
        connected_activities_required: '請選擇關聯活動',
        fault_desc_placeholder:
            'a、道路情況、駕駛工況、客戶操作、儀表提示、車輛表現\n' +
            'b、檢查過程、故障是否復現、互換及結果、車輛修復情況等',
        production_line_measures_Breakpoint_placeholder: '產線改進方案及產線／零件斷點資訊',
        breakpoint_placeholder: '售後維修方案，售後方案釋放時間',
        process_placeholder:
            'a、案例上升情況\n' +
            'b、零件回運情況\n' +
            'c、原因分析計畫\n' +
            'd、解決措施\n' +
            'e、活動開展情況\n' +
            'f、案例關閉情況等',
        historical_information: '歷史資訊',
        is_intensive_monitoring: '是否重點追蹤',
        partOrSoftwareNum: '零件號／軟體版本號',
        closeDate: '關閉時間',
        original_content: '修改前內容',
        modified_time: '修改時間',
        modified_by: '修改人',
        exp_doc_details: '單據明細匯出',
        exp_report_data: '報表資料匯出',
    },
    // 克罗地亚
    hrHR: {
        customs_declaration_unit: 'Carinska deklaracijska jedinica',
        theme: 'Tema',
        model: 'Model',
        problem_state: 'Status problema',
        TAC_submit_date: 'Datum podnošenja TAC-u',
        level: 'Razina',
        type: 'Vrsta',
        vehicle_involved: 'Povezane aktivnosti',
        activity_code: 'Kôd aktivnosti',
        activity_name: 'Naziv aktivnosti',
        connected_activities: 'Povezane aktivnosti',
        connected_activities_remarks: 'Napomene o povezanim aktivnostima',
        system_problems: 'Problemi sustava',
        quantity: 'Količina',
        engine_type: 'Vrsta motora',
        gearbox_type: 'Vrsta mjenjača',
        reporting_country: 'Zemlja prijave',
        region: 'Regija prijave',
        date_of_feedback_to_QA: 'Datum povratne informacije QA-u',
        required_part_return_date: 'Traženi datum vraćanja dijela',
        date_of_parts_delivery_to_QA: 'Datum isporuke dijelova QA-u',
        solution_release_date: 'Datum objave rješenja',
        solution_target_date: 'Ciljani datum rješenja',
        end_date: 'Završni datum',
        difference: 'Razlika',
        QA_weekday: 'Radni dani QA-a',
        fault_description: 'Opis kvara',
        root_cause: 'Temeljni uzrok',
        production_line_measures_Breakpoint: 'Mjere na proizvodnoj liniji / točka prekida',
        breakpoint: 'Mjere nakon prodaje / točka prekida',
        process: 'Najnoviji napredak',
        technical_document_attachments: 'Prilozi tehničkih dokumenata',
        connected_activities_required: 'Odaberite povezanu aktivnost',
        fault_desc_placeholder:
            'a. Stanje ceste, uvjeti vožnje, radnje korisnika, upozorenja na ploči s instrumenima, ponašanje vozila\n' +
            'b. Proces provjere, je li se kvar ponovio, zamjena i rezultati, stanje popravka vozila itd.',
        production_line_measures_Breakpoint_placeholder:
            'Plan poboljšanja proizvodne linije i informacije o točki prekida linije/dijelova',
        breakpoint_placeholder:
            'Plan servisiranja nakon prodaje, vrijeme objave plana nakon prodaje',
        process_placeholder:
            'a. Eskalacija slučaja\n' +
            'b. Stanje vraćanja dijelova\n' +
            'c. Plan analize uzroka\n' +
            'd. Mjere za rješavanje\n' +
            'e. Stanje provedbe aktivnosti\n' +
            'f. Stanje zatvaranja slučaja itd.',
        historical_information: 'Povijesne informacije',
        is_intensive_monitoring: 'Podliježe li intenzivnom praćenju?',
        partOrSoftwareNum: 'Broj dijela / verzija softvera',
        closeDate: 'Vrijeme zatvaranja',
        original_content: 'Sadržaj prije izmjene',
        modified_time: 'Vrijeme izmjene',
        modified_by: 'Izmijenio/la',
        exp_doc_details: 'Izvoz detalja dokumenata',
        exp_report_data: 'Izvoz podataka iz izvještaja',
    },
    // 拉脱维亚
    lvLV: {
        customs_declaration_unit: 'Muitas deklarēšanas vienība',
        theme: 'Tēma',
        model: 'Modelis',
        problem_state: 'Problēmas statuss',
        TAC_submit_date: 'TAC iesniegšanas datums',
        level: 'Līmenis',
        type: 'Veids',
        vehicle_involved: 'Saistītās aktivitātes',
        activity_code: 'Aktivitātes kods',
        activity_name: 'Aktivitātes nosaukums',
        connected_activities: 'Sasaistītās aktivitātes',
        connected_activities_remarks: 'Piezīmes par sasaistītajām aktivitātēm',
        system_problems: 'Sistēmas problēmas',
        quantity: 'Daudzums',
        engine_type: 'Dzinēja tips',
        gearbox_type: 'Ātrumkārbas tips',
        reporting_country: 'Ziņošanas valsts',
        region: 'Ziņošanas reģions',
        date_of_feedback_to_QA: 'Atsauksmes sniegšanas datums QA',
        required_part_return_date: 'Nepieciešamais detaļas atgriešanas datums',
        date_of_parts_delivery_to_QA: 'Detaļu piegādes datums QA',
        solution_release_date: 'Risinājuma publicēšanas datums',
        solution_target_date: 'Mērķa datums risinājumam',
        end_date: 'Beigu datums',
        difference: 'Atšķirība',
        QA_weekday: 'QA darba dienas',
        fault_description: 'Defekta apraksts',
        root_cause: 'Pamatcēlonis',
        production_line_measures_Breakpoint: 'Ražošanas līnijas pasākumi / lūzuma punkts',
        breakpoint: 'Pasākumi pēc pārdošanas / lūzuma punkts',
        process: 'Jaunākie panākumi',
        technical_document_attachments: 'Tehnisko dokumentu pielikumi',
        connected_activities_required: 'Lūdzu, izvēlieties saistīto aktivitāti',
        fault_desc_placeholder:
            'a. Ceļa apstākļi, braukšanas režīms, klienta darbības, instrumentu panelis, transportlīdzekļa uzvedība\n' +
            'b. Pārbaudes process, vai defekts atkārtojas, nomaiņa un rezultāti, transportlīdzekļa remonta stāvoklis utt.',
        production_line_measures_Breakpoint_placeholder:
            'Ražošanas līnijas uzlabošanas plāns un informācija par līnijas/detaļu lūzuma punktu',
        breakpoint_placeholder:
            'Remonta plāns pēc pārdošanas, pēcpārdošanas plāna izlaišanas laiks',
        process_placeholder:
            'a. Gadījuma eskalācija\n' +
            'b. Detaļu atgriešanas stāvoklis\n' +
            'c. Cēloņu analīzes plāns\n' +
            'd. Risinājuma pasākumi\n' +
            'e. Aktivitāšu īstenošanas stāvoklis\n' +
            'f. Gadījuma slēgšanas stāvoklis utt.',
        historical_information: 'Vēsturiskā informācija',
        is_intensive_monitoring: 'Vai tiek intensīvi uzraudzīts?',
        partOrSoftwareNum: 'Detaļas numurs / programmatūras versija',
        closeDate: 'Slēgšanas laiks',
        original_content: 'Saturs pirms izmaiņām',
        modified_time: 'Izmaiņu laiks',
        modified_by: 'Izmainīja',
        exp_doc_details: 'Dokumentu detaļu eksports',
        exp_report_data: 'Atskaites datu eksports',
    },
    // 立陶宛
    ltLT: {
        customs_declaration_unit: 'Muitinės deklaravimo vienetas',
        theme: 'Tema',
        model: 'Modelis',
        problem_state: 'Problemos būsena',
        TAC_submit_date: 'TAC pateikimo data',
        level: 'Lygis',
        type: 'Tipas',
        vehicle_involved: 'Susijusios veiklos',
        activity_code: 'Veiklos kodas',
        activity_name: 'Veiklos pavadinimas',
        connected_activities: 'Susijusios veiklos',
        connected_activities_remarks: 'Pastabos dėl susijusių veiklų',
        system_problems: 'Sistemos problemos',
        quantity: 'Kiekis',
        engine_type: 'Variklio tipas',
        gearbox_type: 'Pavarų dėžės tipas',
        reporting_country: 'Pranešanti šalis',
        region: 'Pranešantis regionas',
        date_of_feedback_to_QA: 'Atsiliepimo pateikimo QA data',
        required_part_return_date: 'Reikalaujama detalių grąžinimo data',
        date_of_parts_delivery_to_QA: 'Detalių pristatymo į QA data',
        solution_release_date: 'Sprendimo išleidimo data',
        solution_target_date: 'Sprendimo tikslinė data',
        end_date: 'Pabaigos data',
        difference: 'Skirtumas',
        QA_weekday: 'QA darbo dienos',
        fault_description: 'Gedimo aprašymas',
        root_cause: 'Pagrindinė priežastis',
        production_line_measures_Breakpoint: 'Gamytinės linijos priemonės / lūžio taškas',
        breakpoint: 'Priemonės po pardavimo / lūžio taškas',
        process: 'Naujausi pasiekimai',
        technical_document_attachments: 'Techninių dokumentų priedai',
        connected_activities_required: 'Pasirinkite susijusią veiklą',
        fault_desc_placeholder:
            'a. Kelio sąlygos, vairavimo režimas, kliento veiksmai, prietaisų skydelio signalai, transporto priemonės elgsena\n' +
            'b. Tikrinimo procesas, ar gedimas pasikartoja, keitimas ir rezultatai, transporto priemonės taisymo būklė ir kt.',
        production_line_measures_Breakpoint_placeholder:
            'Gamytinės linijos patobulinimo planas ir informacija apie linijos/detalių lūžio tašką',
        breakpoint_placeholder: 'Remonto planas po pardavimo, po pardavimo plano išleidimo laikas',
        process_placeholder:
            'a. Atvejo eskalavimas\n' +
            'b. Detalių grąžinimo būklė\n' +
            'c. Priežasčių analizės planas\n' +
            'd. Sprendimo priemonės\n' +
            'e. Veiklos vykdymo būklė\n' +
            'f. Atvejo uždarymo būklė ir kt.',
        historical_information: 'Istorinė informacija',
        is_intensive_monitoring: 'Ar stebimas intensyviai?',
        partOrSoftwareNum: 'Detalės numeris / programinės įrangos versija',
        closeDate: 'Uždarymo laikas',
        original_content: 'Turinys prieš pakeitimą',
        modified_time: 'Pakeitimo laikas',
        modified_by: 'Pakeitė',
        exp_doc_details: 'Dokumentų duomenų eksportas',
        exp_report_data: 'Ataskaitos duomenų eksportas',
    },
    // 罗马尼亚
    roRO: {
        customs_declaration_unit: 'Unitate declarație vamală',
        theme: 'Tematică',
        model: 'Model',
        problem_state: 'Stare problemă',
        TAC_submit_date: 'Data depunerii TAC',
        level: 'Nivel',
        type: 'Tip',
        vehicle_involved: 'Activități implicate',
        activity_code: 'Cod activitate',
        activity_name: 'Nume activitate',
        connected_activities: 'Activități asociate',
        connected_activities_remarks: 'Observații activități asociate',
        system_problems: 'Probleme de sistem',
        quantity: 'Cantitate',
        engine_type: 'Tip motor',
        gearbox_type: 'Tip cutie de viteze',
        reporting_country: 'Țară raportare',
        region: 'Regiune raportare',
        date_of_feedback_to_QA: 'Data feedback-ului către QA',
        required_part_return_date: 'Data solicitată pentru returnarea piesei',
        date_of_parts_delivery_to_QA: 'Data livrării pieselor către QA',
        solution_release_date: 'Data lansării soluției',
        solution_target_date: 'Data țintă pentru soluție',
        end_date: 'Data încheierii',
        difference: 'Diferență',
        QA_weekday: 'Zile lucrătoare QA',
        fault_description: 'Descriere defect',
        root_cause: 'Cauză fundamentală',
        production_line_measures_Breakpoint: 'Măsuri linie de producție / punct de întrerupere',
        breakpoint: 'Măsuri post-vânzare / punct de întrerupere',
        process: 'Cele mai recente progrese',
        technical_document_attachments: 'Atașamente documente tehnice',
        connected_activities_required: 'Selectați o activitate asociată',
        fault_desc_placeholder:
            'a. Condiții de drum, regim de conducere, acțiuni client, indicații bord, comportament vehicul\n' +
            'b. Proces de verificare, dacă defectul se reproduce, schimb și rezultate, stare reparație vehicul etc.',
        production_line_measures_Breakpoint_placeholder:
            'Plan îmbunătățire linie de producție și informații despre punctul de întrerupere al liniei/pieselor',
        breakpoint_placeholder:
            'Plan reparații post-vânzare, momentul lansării planului post-vânzare',
        process_placeholder:
            'a. Escaladare caz\n' +
            'b. Stare returnare piese\n' +
            'c. Plan analiză cauză\n' +
            'd. Măsuri de remediere\n' +
            'e. Stare desfășurare activitate\n' +
            'f. Stare închidere caz etc.',
        historical_information: 'Informații istorice',
        is_intensive_monitoring: 'Este urmărit intens?',
        partOrSoftwareNum: 'Număr piesă / versiune software',
        closeDate: 'Timp închidere',
        original_content: 'Conținut înainte de modificare',
        modified_time: 'Timp modificare',
        modified_by: 'Modificat de',
        exp_doc_details: 'Export detalii documente',
        exp_report_data: 'Export date raport',
    },
    // 挪威博克马尔
    nbNO: {
        customs_declaration_unit: 'Tolldokumentasjonenhet',
        theme: 'Tema',
        model: 'Modell',
        problem_state: 'Problemstatus',
        TAC_submit_date: 'TAC-innsendelsesdato',
        level: 'Nivå',
        type: 'Type',
        vehicle_involved: 'Relaterte aktiviteter',
        activity_code: 'Aktivitetskode',
        activity_name: 'Aktivitetsnavn',
        connected_activities: 'Tilknyttede aktiviteter',
        connected_activities_remarks: 'Merknader til tilknyttede aktiviteter',
        system_problems: 'Systemproblemer',
        quantity: 'Antall',
        engine_type: 'Motortype',
        gearbox_type: 'Girkassetype',
        reporting_country: 'Rapporterende land',
        region: 'Rapporterende region',
        date_of_feedback_to_QA: 'Dato for tilbakemelding til QA',
        required_part_return_date: 'Ønsket returdato for del',
        date_of_parts_delivery_to_QA: 'Dato for levering av deler til QA',
        solution_release_date: 'Løsningspubliseringsdato',
        solution_target_date: 'Måldato for løsning',
        end_date: 'Sluttdato',
        difference: 'Forskjell',
        QA_weekday: 'QA-arbeidsdager',
        fault_description: 'Feilbeskrivelse',
        root_cause: 'Rotårsak',
        production_line_measures_Breakpoint: 'Tiltak på produksjonslinje / brytningspunkt',
        breakpoint: 'Ettermarkedsaktiviteter / brytningspunkt',
        process: 'Siste fremgang',
        technical_document_attachments: 'Vedlegg med tekniske dokumenter',
        connected_activities_required: 'Velg en tilknyttet aktivitet',
        fault_desc_placeholder:
            'a. Vei­forhold, kjøreforhold, kunde­handlinger, instrument­varsler, kjøretøyets oppførsel\n' +
            'b. Kontroll­prosess, om feilen kan gjenskapes, bytte og resultater, reparasjonsstatus for kjøretøyet osv.',
        production_line_measures_Breakpoint_placeholder:
            'Forbedringsplan for produksjonslinje og informasjon om brytningspunkt for linje/deler',
        breakpoint_placeholder:
            'Serviceplan etter salg, tidspunkt for utgivelse av ettermarkedsplan',
        process_placeholder:
            'a. Sakseskalering\n' +
            'b. Status for retur av deler\n' +
            'c. Plan for årsaksanalyse\n' +
            'd. Løsnings­tiltak\n' +
            'e. Status for aktivitetens gjennomføring\n' +
            'f. Status for sakslukking osv.',
        historical_information: 'Historisk informasjon',
        is_intensive_monitoring: 'Skal det følges spesielt nøye?',
        partOrSoftwareNum: 'Delnummer / programvareversjon',
        closeDate: 'Lukketidspunkt',
        original_content: 'Innhold før endring',
        modified_time: 'Endringstidspunkt',
        modified_by: 'Endret av',
        exp_doc_details: 'Eksportér dokumentdetaljer',
        exp_report_data: 'Eksportér rapportdata',
    },
    // 葡萄牙语巴西
    ptBX: {
        customs_declaration_unit: 'Unidade de Declaração Aduaneira',
        theme: 'Tema',
        model: 'Modelo',
        problem_state: 'Estado do Problema',
        TAC_submit_date: 'Data de Envio ao TAC',
        level: 'Nível',
        type: 'Tipo',
        vehicle_involved: 'Atividades Envolvidas',
        activity_code: 'Código da Atividade',
        activity_name: 'Nome da Atividade',
        connected_activities: 'Atividades Relacionadas',
        connected_activities_remarks: 'Observações das Atividades Relacionadas',
        system_problems: 'Problemas do Sistema',
        quantity: 'Quantidade',
        engine_type: 'Tipo de Motor',
        gearbox_type: 'Tipo de Câmbio',
        reporting_country: 'País de Relato',
        region: 'Região de Relato',
        date_of_feedback_to_QA: 'Data do Feedback para QA',
        required_part_return_date: 'Data Solicitada para Retorno da Peça',
        date_of_parts_delivery_to_QA: 'Data de Entrega das Peças ao QA',
        solution_release_date: 'Data de Lançamento da Solução',
        solution_target_date: 'Data Alvo da Solução',
        end_date: 'Data de Encerramento',
        difference: 'Diferença',
        QA_weekday: 'Dias Úteis do QA',
        fault_description: 'Descrição da Falha',
        root_cause: 'Causa Raiz',
        production_line_measures_Breakpoint: 'Medidas na Linha de Produção / Ponto de Ruptura',
        breakpoint: 'Medidas Pós-Venda / Ponto de Ruptura',
        process: 'Últimos Avanços',
        technical_document_attachments: 'Anexos de Documentos Técnicos',
        connected_activities_required: 'Selecione uma atividade relacionada',
        fault_desc_placeholder:
            'a. Condições da estrada, condições de condução, operação do cliente, alertas no painel, comportamento do veículo\n' +
            'b. Processo de inspeção, se a falha foi reproduzida, troca e resultados, situação do reparo do veículo etc.',
        production_line_measures_Breakpoint_placeholder:
            'Plano de melhoria da linha de produção e informações sobre o ponto de ruptura da linha/peças',
        breakpoint_placeholder:
            'Plano de manutenção pós-venda, data de liberação do plano pós-venda',
        process_placeholder:
            'a. Escalonamento do caso\n' +
            'b. Situação do retorno das peças\n' +
            'c. Plano de análise de causa\n' +
            'd. Medidas corretivas\n' +
            'e. Situação da execução da atividade\n' +
            'f. Situação de encerramento do caso etc.',
        historical_information: 'Informações Históricas',
        is_intensive_monitoring: 'É acompanhado com foco especial?',
        partOrSoftwareNum: 'Número da peça / Versão do software',
        closeDate: 'Horário de Fechamento',
        original_content: 'Conteúdo antes da alteração',
        modified_time: 'Horário da alteração',
        modified_by: 'Alterado por',
        exp_doc_details: 'Exportar Detalhes do Documento',
        exp_report_data: 'Exportar Dados do Relatório',
    },
    // 瑞典语
    svSE: {
        customs_declaration_unit: 'Tulldeklarationsenhet',
        theme: 'Tema',
        model: 'Modell',
        problem_state: 'Problemstatus',
        TAC_submit_date: 'TAC-insändningsdatum',
        level: 'Nivå',
        type: 'Typ',
        vehicle_involved: 'Relaterade aktiviteter',
        activity_code: 'Aktivitetskod',
        activity_name: 'Aktivitetsnamn',
        connected_activities: 'Kopplade aktiviteter',
        connected_activities_remarks: 'Kommentarer till kopplade aktiviteter',
        system_problems: 'Systemproblem',
        quantity: 'Antal',
        engine_type: 'Motortyp',
        gearbox_type: 'Växellådets typ',
        reporting_country: 'Rapporterande land',
        region: 'Rapporterande region',
        date_of_feedback_to_QA: 'Datum för återkoppling till QA',
        required_part_return_date: 'Önskat returdatum för del',
        date_of_parts_delivery_to_QA: 'Datum för leverans av delar till QA',
        solution_release_date: 'Publiceringsdatum för lösning',
        solution_target_date: 'Måldatum för lösning',
        end_date: 'Slutdatum',
        difference: 'Skillnad',
        QA_weekday: 'QA-arbetsdagar',
        fault_description: 'Felförklaring',
        root_cause: 'Rotorsak',
        production_line_measures_Breakpoint: 'Åtgärder på produktionslinjen / brytpunkt',
        breakpoint: 'Åtgärder efter försäljning / brytpunkt',
        process: 'Senaste framsteg',
        technical_document_attachments: 'Bilagor med tekniska dokument',
        connected_activities_required: 'Välj en kopplad aktivitet',
        fault_desc_placeholder:
            'a. Vägförhållanden, körförhållanden, kundens handlingar, instrumentindikationer, fordonets beteende\n' +
            'b. Granskningsprocess, om felet kan återskapas, byte och resultat, fordonets reparationstillstånd etc.',
        production_line_measures_Breakpoint_placeholder:
            'Förbättringsplan för produktionslinjen och information om brytpunkt för linje/delar',
        breakpoint_placeholder:
            'Serviceplan efter försäljning, tidpunkt för publicering av efterförsäljningsplan',
        process_placeholder:
            'a. Ärendeeskalering\n' +
            'b. Status för retur av delar\n' +
            'c. Plan för orsaksanalys\n' +
            'd. Åtgärder för lösning\n' +
            'e. Status för genomförande av aktivitet\n' +
            'f. Status för ärendestängning etc.',
        historical_information: 'Historisk information',
        is_intensive_monitoring: 'Ska det följas extra noga?',
        partOrSoftwareNum: 'Delnummer / programvaruversion',
        closeDate: 'Stängningstidpunkt',
        original_content: 'Innehåll före ändring',
        modified_time: 'Ändringstidpunkt',
        modified_by: 'Ändrad av',
        exp_doc_details: 'Exportera dokumentdetaljer',
        exp_report_data: 'Exportera rapportdata',
    },
    // 斯洛伐克
    skSK: {
        customs_declaration_unit: 'Colná deklaračná jednotka',
        theme: 'Téma',
        model: 'Model',
        problem_state: 'Stav problému',
        TAC_submit_date: 'Dátum odoslania TAC',
        level: 'Úroveň',
        type: 'Typ',
        vehicle_involved: 'Zapojené aktivity',
        activity_code: 'Kód aktivity',
        activity_name: 'Názov aktivity',
        connected_activities: 'Prepojené aktivity',
        connected_activities_remarks: 'Poznámky k prepojeným aktivitám',
        system_problems: 'Problémy systému',
        quantity: 'Množstvo',
        engine_type: 'Typ motora',
        gearbox_type: 'Typ prevodovky',
        reporting_country: 'Nahlásená krajina',
        region: 'Nahlásený región',
        date_of_feedback_to_QA: 'Dátum spätnej väzby pre QA',
        required_part_return_date: 'Požadovaný dátum vrátenia súčiastky',
        date_of_parts_delivery_to_QA: 'Dátum doručenia súčiastok do QA',
        solution_release_date: 'Dátum zverejnenia riešenia',
        solution_target_date: 'Cieľový dátum riešenia',
        end_date: 'Dátum ukončenia',
        difference: 'Rozdiel',
        QA_weekday: 'Pracovné dni QA',
        fault_description: 'Popis poruchy',
        root_cause: 'Hlavná príčina',
        production_line_measures_Breakpoint: 'Opatrenia na výrobnej linke / bod prerušenia',
        breakpoint: 'Opatrenia po predaji / bod prerušenia',
        process: 'Najnovší pokrok',
        technical_document_attachments: 'Prílohy technických dokumentov',
        connected_activities_required: 'Vyberte prepojenú aktivitu',
        fault_desc_placeholder:
            'a. Stav cesty, jazdné podmienky, činnosti zákazníka, indikácie na palubnej doske, správanie vozidla\n' +
            'b. Proces kontroly, či sa porucha opakuje, výmena a výsledky, stav opravy vozidla atď.',
        production_line_measures_Breakpoint_placeholder:
            'Plán zlepšenia výrobnej linky a informácie o bode prerušenia linky/súčiastok',
        breakpoint_placeholder: 'Plán údržby po predaji, dátum zverejnenia plánu po predaji',
        process_placeholder:
            'a. Eskalácia prípadu\n' +
            'b. Stav vrátenia súčiastok\n' +
            'c. Plán analýzy príčin\n' +
            'd. Opatrenia na riešenie\n' +
            'e. Stav realizácie aktivity\n' +
            'f. Stav uzatvorenia prípadu atď.',
        historical_information: 'Historické informácie',
        is_intensive_monitoring: 'Je sledované intenzívne?',
        partOrSoftwareNum: 'Číslo súčiastky / verzia softvéru',
        closeDate: 'Čas uzatvorenia',
        original_content: 'Obsah pred úpravou',
        modified_time: 'Čas úpravy',
        modified_by: 'Upravil/a',
        exp_doc_details: 'Export detailov dokumentov',
        exp_report_data: 'Export údajov z reportu',
    },
    // 斯洛文尼亚
    slSI: {
        customs_declaration_unit: 'Carinska deklaracijska enota',
        theme: 'Tema',
        model: 'Model',
        problem_state: 'Stanje težave',
        TAC_submit_date: 'Datum oddaje TAC',
        level: 'Raven',
        type: 'Tip',
        vehicle_involved: 'Vključene dejavnosti',
        activity_code: 'Koda dejavnosti',
        activity_name: 'Ime dejavnosti',
        connected_activities: 'Povezane dejavnosti',
        connected_activities_remarks: 'Opombe k povezanim dejavnostim',
        system_problems: 'Težave s sistemom',
        quantity: 'Količina',
        engine_type: 'Tip motorja',
        gearbox_type: 'Tip menjalnika',
        reporting_country: 'Država poročanja',
        region: 'Regija poročanja',
        date_of_feedback_to_QA: 'Datum povratne informacije za QA',
        required_part_return_date: 'Zahtevan datum vračila dela',
        date_of_parts_delivery_to_QA: 'Datum dostave delov v QA',
        solution_release_date: 'Datum objave rešitve',
        solution_target_date: 'Ciljni datum rešitve',
        end_date: 'Končni datum',
        difference: 'Razlika',
        QA_weekday: 'Delovni dnevi QA',
        fault_description: 'Opis okvare',
        root_cause: 'Korenski vzrok',
        production_line_measures_Breakpoint: 'Ukrepi na proizvodni liniji / prelomna točka',
        breakpoint: 'Ukrepi po prodaji / prelomna točka',
        process: 'Najnovejši napredek',
        technical_document_attachments: 'Priloge tehničnih dokumentov',
        connected_activities_required: 'Izberite povezano dejavnost',
        fault_desc_placeholder:
            'a. Stanje ceste, pogoji vožnje, dejanja stranke, opozorila na instrumentih, obnašanje vozila\n' +
            'b. Postopek pregleda, ali se okvara ponovi, zamenjava in rezultati, stanje popravila vozila itd.',
        production_line_measures_Breakpoint_placeholder:
            'Načrt izboljšave proizvodne linije in informacije o prelomni točki linije/delov',
        breakpoint_placeholder: 'Načrt servisiranja po prodaji, čas objave načrta po prodaji',
        process_placeholder:
            'a. Eskalacija primera\n' +
            'b. Stanje vračila delov\n' +
            'c. Načrt analize vzrokov\n' +
            'd. Rešitveni ukrepi\n' +
            'e. Stanje izvajanja dejavnosti\n' +
            'f. Stanje zaprtja primera itd.',
        historical_information: 'Zgodovinski podatki',
        is_intensive_monitoring: 'Ali je intenzivno spremljan?',
        partOrSoftwareNum: 'Številka dela / različica programske opreme',
        closeDate: 'Čas zaprtja',
        original_content: 'Vsebina pred spremembo',
        modified_time: 'Čas spremembe',
        modified_by: 'Spremenil/a',
        exp_doc_details: 'Izvoz podrobnosti dokumentov',
        exp_report_data: 'Izvoz podatkov poročila',
    },
    // 泰语
    thTH: {
        customs_declaration_unit: 'หน่วยงานแจ้งพิธีการศุลกากร',
        theme: 'หัวข้อ',
        model: 'รุ่น',
        problem_state: 'สถานะปัญหา',
        TAC_submit_date: 'วันที่ส่ง TAC',
        level: 'ระดับ',
        type: 'ประเภท',
        vehicle_involved: 'กิจกรรมที่เกี่ยวข้อง',
        activity_code: 'รหัสกิจกรรม',
        activity_name: 'ชื่อกิจกรรม',
        connected_activities: 'กิจกรรมที่เชื่อมโยง',
        connected_activities_remarks: 'หมายเหตุกิจกรรมที่เชื่อมโยง',
        system_problems: 'ปัญหาระบบ',
        quantity: 'จำนวน',
        engine_type: 'ประเภทเครื่องยนต์',
        gearbox_type: 'ประเภทเกียร์',
        reporting_country: 'ประเทศที่รายงาน',
        region: 'ภูมิภาคที่รายงาน',
        date_of_feedback_to_QA: 'วันที่ให้ข้อมูลย้อนกลับถึง QA',
        required_part_return_date: 'วันที่กำหนดให้ส่งคืนชิ้นส่วน',
        date_of_parts_delivery_to_QA: 'วันที่นำส่งชิ้นส่วนถึง QA',
        solution_release_date: 'วันที่เผยแพร่แนวทางแก้ไข',
        solution_target_date: 'วันที่เป้าหมายของแนวทางแก้ไข',
        end_date: 'วันที่สิ้นสุด',
        difference: 'ความแตกต่าง',
        QA_weekday: 'วันทำการ QA',
        fault_description: 'คำอธิบายความผิดพลาด',
        root_cause: 'สาเหตุหลัก',
        production_line_measures_Breakpoint: 'มาตรการสายการผลิต/จุดหยุด',
        breakpoint: 'มาตรการหลังการขาย/จุดหยุด',
        process: 'ความคืบหน้าล่าสุด',
        technical_document_attachments: 'เอกสารแนบทางเทคนิค',
        connected_activities_required: 'กรุณาเลือกกิจกรรมที่เชื่อมโยง',
        fault_desc_placeholder:
            'ก. สภาพถนน สภาพการขับขี่ การปฏิบัติของลูกค้า คำเตือนบนหน้าปัด สมรรถนะของรถยนต์\n' +
            'ข. กระบวนการตรวจสอบ ความผิดพลาดสามารถทำซ้ำได้หรือไม่ การสลับชิ้นส่วนและผลลัพธ์ สถานะการซ่อมแซมรถยนต์ เป็นต้น',
        production_line_measures_Breakpoint_placeholder:
            'แผนปรับปรุงสายการผลิตและข้อมูลจุดหยุดของสายการผลิต/ชิ้นส่วน',
        breakpoint_placeholder: 'แผนซ่อมบำรุงหลังการขาย เวลาเผยแพร่แผนหลังการขาย',
        process_placeholder:
            'ก. การยกระดับกรณี\n' +
            'ข. สถานะการส่งคืนชิ้นส่วน\n' +
            'ค. แผนวิเคราะห์สาเหตุ\n' +
            'ง. มาตรการแก้ไข\n' +
            'จ. สถานะการดำเนินกิจกรรม\n' +
            'ฉ. สถานะการปิดกรณี เป็นต้น',
        historical_information: 'ข้อมูลประวัติ',
        is_intensive_monitoring: 'ติดตามอย่างเข้มงวดหรือไม่',
        partOrSoftwareNum: 'หมายเลขชิ้นส่วน/เวอร์ชันซอฟต์แวร์',
        closeDate: 'เวลาปิด',
        original_content: 'เนื้อหาก่อนแก้ไข',
        modified_time: 'เวลาแก้ไข',
        modified_by: 'ผู้แก้ไข',
        exp_doc_details: 'ส่งออกข้อมูลรายละเอียดเอกสาร',
        exp_report_data: 'ส่งออกข้อมูลรายงาน',
    },
    // 乌克兰语
    ukUA: {
        customs_declaration_unit: 'Митна деклараційна одиниця',
        theme: 'Тема',
        model: 'Модель',
        problem_state: 'Стан проблеми',
        TAC_submit_date: 'Дата подання до TAC',
        level: 'Рівень',
        type: 'Тип',
        vehicle_involved: 'Задіяні заходи',
        activity_code: 'Код заходу',
        activity_name: 'Назва заходу',
        connected_activities: 'Пов’язані заходи',
        connected_activities_remarks: 'Примітки до пов’язаних заходів',
        system_problems: 'Проблеми системи',
        quantity: 'Кількість',
        engine_type: 'Тип двигуна',
        gearbox_type: 'Тип коробки передач',
        reporting_country: 'Країна звітування',
        region: 'Регіон звітування',
        date_of_feedback_to_QA: 'Дата надання зворотного зв’язку до QA',
        required_part_return_date: 'Бажана дата повернення деталі',
        date_of_parts_delivery_to_QA: 'Дата доставки деталей до QA',
        solution_release_date: 'Дата публікації рішення',
        solution_target_date: 'Цільова дата рішення',
        end_date: 'Дата завершення',
        difference: 'Різниця',
        QA_weekday: 'Робочі дні QA',
        fault_description: 'Опис несправності',
        root_cause: 'Коренева причина',
        production_line_measures_Breakpoint: 'Заходи на виробничій лінії / точка розриву',
        breakpoint: 'Заходи післяпродажного обслуговування / точка розриву',
        process: 'Останній прогрес',
        technical_document_attachments: 'Додатки технічних документів',
        connected_activities_required: 'Будь ласка, оберіть пов’язаний захід',
        fault_desc_placeholder:
            'а. Стан дороги, умови водіння, дії клієнта, індикація приладової панелі, поведінка автомобіля\n' +
            'б. Процес перевірки, чи відтворюється несправність, заміна та результати, стан ремонту автомобіля тощо',
        production_line_measures_Breakpoint_placeholder:
            'План покращення виробничої лінії та інформація про точку розриву лінії/деталей',
        breakpoint_placeholder:
            'План післяпродажного обслуговування, час випуску післяпродажного плану',
        process_placeholder:
            'а. Ескалація випадку\n' +
            'б. Стан повернення деталей\n' +
            'в. План аналізу причин\n' +
            'г. Заходи щодо вирішення\n' +
            'д. Стан проведення заходу\n' +
            'е. Стан закриття випадку тощо',
        historical_information: 'Історична інформація',
        is_intensive_monitoring: 'Чи ведеться посилене спостереження?',
        partOrSoftwareNum: 'Номер деталі / версія програмного забезпечення',
        closeDate: 'Час закриття',
        original_content: 'Вміст до змін',
        modified_time: 'Час зміни',
        modified_by: 'Змінив(ла)',
        exp_doc_details: 'Експорт деталей документів',
        exp_report_data: 'Експорт даних звіту',
    },
    // 希腊语
    elGR: {
        customs_declaration_unit: 'Μονάδα τελωνιακής δήλωσης',
        theme: 'Θέμα',
        model: 'Μοντέλο',
        problem_state: 'Κατάσταση προβλήματος',
        TAC_submit_date: 'Ημερομηνία υποβολής TAC',
        level: 'Επίπεδο',
        type: 'Τύπος',
        vehicle_involved: 'Συμμετέχουσες δραστηριότητες',
        activity_code: 'Κωδικός δραστηριότητας',
        activity_name: 'Όνομα δραστηριότητας',
        connected_activities: 'Συνδεδεμένες δραστηριότητες',
        connected_activities_remarks: 'Σχόλια συνδεδεμένων δραστηριοτήτων',
        system_problems: 'Προβλήματα συστήματος',
        quantity: 'Ποσότητα',
        engine_type: 'Τύπος κινητήρα',
        gearbox_type: 'Τύπος κιβωτίου ταχυτήτων',
        reporting_country: 'Χώρα αναφοράς',
        region: 'Περιοχή αναφοράς',
        date_of_feedback_to_QA: 'Ημερομηνία ανατροφοδότησης στο QA',
        required_part_return_date: 'Απαιτούμενη ημερομηνία επιστροφής εξαρτήματος',
        date_of_parts_delivery_to_QA: 'Ημερομηνία παράδοσης εξαρτημάτων στο QA',
        solution_release_date: 'Ημερομηνία δημοσίευσης λύσης',
        solution_target_date: 'Στόχος ημερομηνίας λύσης',
        end_date: 'Ημερομηνία λήξης',
        difference: 'Διαφορά',
        QA_weekday: 'Εργάσιμες ημέρες QA',
        fault_description: 'Περιγραφή βλάβης',
        root_cause: 'Βασική αιτία',
        production_line_measures_Breakpoint: 'Μέτρα γραμμής παραγωγής / σημείο διακοπής',
        breakpoint: 'Μέτρα μετά την πώληση / σημείο διακοπής',
        process: 'Τελευταία πρόοδος',
        technical_document_attachments: 'Συνημμένα τεχνικά έγγραφα',
        connected_activities_required: 'Παρακαλούμε επιλέξτε συνδεδεμένη δραστηριότητα',
        fault_desc_placeholder:
            'α. Συνθήκες οδοστρώματος, συνθήκες οδήγησης, ενέργειες πελάτη, ενδείξεις οργάνων, συμπεριφορά οχήματος\n' +
            'β. Διαδικασία ελέγχου, αναπαραγωγή βλάβης, ανταλλαγή και αποτελέσματα, κατάσταση επισκευής οχήματος κ.λπ.',
        production_line_measures_Breakpoint_placeholder:
            'Σχέδιο βελτίωσης γραμμής παραγωγής και πληροφορίες σημείου διακοπής γραμμής/εξαρτημάτων',
        breakpoint_placeholder:
            'Σχέδιο συντήρησης μετά την πώληση, χρόνος κυκλοφορίας σχεδίου μετά την πώληση',
        process_placeholder:
            'α. Κλιμάκωση περίπτωσης\n' +
            'β. Κατάσταση επιστροφής εξαρτημάτων\n' +
            'γ. Σχέδιο ανάλυσης αιτιών\n' +
            'δ. Μέτρα επίλυσης\n' +
            'ε. Κατάσταση εκτέλεσης δραστηριότητας\n' +
            'στ. Κατάσταση κλεισίματος περίπτωσης κ.λπ.',
        historical_information: 'Ιστορικές πληροφορίες',
        is_intensive_monitoring: 'Υπόκειται σε εντατική παρακολούθηση;',
        partOrSoftwareNum: 'Αριθμός εξαρτήματος / έκδοση λογισμικού',
        closeDate: 'Ώρα κλεισίματος',
        original_content: 'Περιεχόμενο πριν την τροποποίηση',
        modified_time: 'Ώρα τροποποίησης',
        modified_by: 'Τροποποιήθηκε από',
        exp_doc_details: 'Εξαγωγή λεπτομερειών εγγράφων',
        exp_report_data: 'Εξαγωγή δεδομένων αναφοράς',
    },
    // 爱沙尼亚
    etEE: {
        customs_declaration_unit: 'Tollideklaratsiooni üksus',
        theme: 'Teema',
        model: 'Mudel',
        problem_state: 'Probleemi olek',
        TAC_submit_date: 'TAC-i esitamise kuupäev',
        level: 'Tase',
        type: 'Tüüp',
        vehicle_involved: 'Seotud tegevused',
        activity_code: 'Tegevuse kood',
        activity_name: 'Tegevuse nimi',
        connected_activities: 'Seotud tegevused',
        connected_activities_remarks: 'Märkused seotud tegevuste kohta',
        system_problems: 'Süsteemiprobleemid',
        quantity: 'Kogus',
        engine_type: 'Mootori tüüp',
        gearbox_type: 'Käigukasti tüüp',
        reporting_country: 'Raporteeriv riik',
        region: 'Raporteeriv piirkond',
        date_of_feedback_to_QA: 'Tagasiside andmise kuupäev QA-le',
        required_part_return_date: 'Nõutav tagastamise kuupäev osale',
        date_of_parts_delivery_to_QA: 'Osaliste kohaletoimetamise kuupäev QA-le',
        solution_release_date: 'Lahenduse avaldamise kuupäev',
        solution_target_date: 'Lahenduse sihtkuupäev',
        end_date: 'Lõppkuupäev',
        difference: 'Erinevus',
        QA_weekday: 'QA tööpäevad',
        fault_description: 'Vea kirjeldus',
        root_cause: 'Põhjus',
        production_line_measures_Breakpoint: 'Tootmisliini meetmed/murdepunkt',
        breakpoint: 'Pärismüügi meetmed/murdepunkt',
        process: 'Viimased edusammud',
        technical_document_attachments: 'Tehniliste dokumentide manused',
        connected_activities_required: 'Palun valige seotud tegevus',
        fault_desc_placeholder:
            'a. Teeolud, sõidutingimused, kliendi tegevused, instrumentide hoiatused, sõiduki käitumine\n' +
            'b. Kontrolliprotsess, kas viga kordub, vahetus ja tulemused, sõiduki remondi seis jne.',
        production_line_measures_Breakpoint_placeholder:
            'Tootmisliini täiustamise plaan ja info murdepunktist liinile/osadele',
        breakpoint_placeholder: 'Pärismüügi hooldusplaan, pärismüügi plaani väljalaske aeg',
        process_placeholder:
            'a. Juhtumi eskaleerimine\n' +
            'b. Osade tagastamise seis\n' +
            'c. Põhjuse analüüsi plaan\n' +
            'd. Lahendusmeetmed\n' +
            'e. Tegevuse läbiviimise seis\n' +
            'f. Juhtumi sulgemise seis jne.',
        historical_information: 'Ajalooline info',
        is_intensive_monitoring: 'Kas jälgitakse tähelepanelikult?',
        partOrSoftwareNum: 'Osa number / tarkvara versioon',
        closeDate: 'Sulgemise aeg',
        original_content: 'Sisu enne muutmist',
        modified_time: 'Muutmise aeg',
        modified_by: 'Muutja',
        exp_doc_details: 'Dokumenditüübide eksport',
        exp_report_data: 'Aruandeandmete eksport',
    },
    // 哈萨克
    kkKZ: {
        customs_declaration_unit: 'Баж баяндау бөлімі',
        theme: 'Тақырып',
        model: 'Модель',
        problem_state: 'Мәселенің күйі',
        TAC_submit_date: 'TAC-қа жіберу күні',
        level: 'Деңгей',
        type: 'Түрі',
        vehicle_involved: 'Қатысқан іс-шаралар',
        activity_code: 'Іс-шара коды',
        activity_name: 'Іс-шара атауы',
        connected_activities: 'Байланысты іс-шаралар',
        connected_activities_remarks: 'Байланысты іс-шараларға түсініктеме',
        system_problems: 'Жүйелік мәселелер',
        quantity: 'Саны',
        engine_type: 'Қозғалтқыш түрі',
        gearbox_type: 'Қорап түрі',
        reporting_country: 'Есеп беру елі',
        region: 'Есеп беру аймағы',
        date_of_feedback_to_QA: 'QA-ға кері байланыс беру күні',
        required_part_return_date: 'Бөлшекті қайтару күні',
        date_of_parts_delivery_to_QA: 'Бөлшектерді QA-ға жеткізу күні',
        solution_release_date: 'Шешімді жариялау күні',
        solution_target_date: 'Шешімнің мақсатты күні',
        end_date: 'Аяқталу күні',
        difference: 'Айырмашылық',
        QA_weekday: 'QA жұмыс күндері',
        fault_description: 'Ақау сипаттамасы',
        root_cause: 'Түбірлі себебі',
        production_line_measures_Breakpoint: 'Өндіріс желісі шаралары/үзіліс нүктесі',
        breakpoint: 'Сатудан кейінгі шаралар/үзіліс нүктесі',
        process: 'Соңғы жаңалықтар',
        technical_document_attachments: 'Техникалық құжаттардың салынған файлдары',
        connected_activities_required: 'Байланысты іс-шараны таңдаңыз',
        fault_desc_placeholder:
            'а. Жол жағдайы, жүру режимі, тұтынушының әрекеттері, прибор тақтасындағы хабарландырулар, көліктің әрекеті\n' +
            'б. Тексеру процесі, ақау қайталануы, алмастыру және нәтижелер, көлікті жөндеу жағдайы т.б.',
        production_line_measures_Breakpoint_placeholder:
            'Өндіріс желісін жақсарту жоспары және желі/бөлшектердің үзіліс нүктесі туралы ақпарат',
        breakpoint_placeholder:
            'Сатудан кейінгі қызмет көрсету жоспары, сатудан кейінгі жоспарды шығару уақыты',
        process_placeholder:
            'а. Жағдайды эскалациялау\n' +
            'б. Бөлшектерді қайтару жағдайы\n' +
            'в. Себептерді талдау жоспары\n' +
            'г. Шешім қабылдау шаралары\n' +
            'д. Іс-шараны жүзеге асыру жағдайы\n' +
            'е. Жағдайды жабу жағдайы т.б.',
        historical_information: 'Тарихи ақпарат',
        is_intensive_monitoring: 'Қатаң бақылауға алынды ма?',
        partOrSoftwareNum: 'Бөлшек нөмірі/бағдарламалық қамтамасыз ету нұсқасы',
        closeDate: 'Жабу уақыты',
        original_content: 'Түзетуден кейінгі мазмұн',
        modified_time: 'Түзету уақыты',
        modified_by: 'Түзеткен',
        exp_doc_details: 'Құжаттардың мазмұнын экспорттау',
        exp_report_data: 'Есеп беру деректерін экспорттау',
    },
    // 希伯来语
    heIL: {
        customs_declaration_unit: 'יחידת הצהרת מכס',
        theme: 'נושא',
        model: 'דגם',
        problem_state: 'מצב הבעיה',
        TAC_submit_date: 'תאריך הגשת TAC',
        level: 'רמה',
        type: 'סוג',
        vehicle_involved: 'פעילויות קשורות',
        activity_code: 'קוד פעילות',
        activity_name: 'שם הפעילות',
        connected_activities: 'פעילויות מקושרות',
        connected_activities_remarks: 'הערות לפעילויות מקושרות',
        system_problems: 'תקלות מערכת',
        quantity: 'כמות',
        engine_type: 'סוג מנוע',
        gearbox_type: 'סוג תיבת הילוכים',
        reporting_country: 'מדינת הדיווח',
        region: 'אזור הדיווח',
        date_of_feedback_to_QA: 'תאריך משוב ל-QA',
        required_part_return_date: 'תאריך דרוש להחזרת חלק',
        date_of_parts_delivery_to_QA: 'תאריך מסירת החלקים ל-QA',
        solution_release_date: 'תאריך שחרור הפתרון',
        solution_target_date: 'תאריך יעד לפתרון',
        end_date: 'תאריך סיום',
        difference: 'הפרש',
        QA_weekday: 'ימי עבודה של QA',
        fault_description: 'תיאור תקלה',
        root_cause: 'סיבת השורש',
        production_line_measures_Breakpoint: 'צעדים בקו הייצור / נקודת שבירה',
        breakpoint: 'צעדים לאחר המכירה / נקודת שבירה',
        process: 'התקדמות אחרונה',
        technical_document_attachments: 'קובצי מסמכים טכניים מצורפים',
        connected_activities_required: 'אנא בחר פעילות מקושרת',
        fault_desc_placeholder:
            'א. מצב הדרך, תנאי נהיגה, פעולות הלקוח, התראות לוח המחוונים, ביצועי הרכב\n' +
            'ב. תהליך בדיקה, האם התקלה חוזרת על עצמה, החלפה ותוצאות, מצב תיקון הרכב וכו\'',
        production_line_measures_Breakpoint_placeholder:
            'תוכנית שיפור לקו הייצור ופרטי נקודת השבירה לקו/לחלקים',
        breakpoint_placeholder: 'תוכנית תיקון לאחר מכירה, זמן שחרור תוכנית לאחר מכירה',
        process_placeholder:
            'א. העלאת המקרה\n' +
            'ב. מצב החזרת החלקים\n' +
            'ג. תוכנית ניתוח סיבות\n' +
            'ד. צעדי פתרון\n' +
            'ה. מצב ביצוע הפעילות\n' +
            'ו. מצב סגירת המקרה וכו\'',
        historical_information: 'מידע היסטורי',
        is_intensive_monitoring: 'האם מדובר במעקב ממוקד?',
        partOrSoftwareNum: 'מספר חלק / גרסת תוכנה',
        closeDate: 'מועד הסגירה',
        original_content: 'תוכן לפני שינוי',
        modified_time: 'מועד השינוי',
        modified_by: 'שונה על ידי',
        exp_doc_details: 'ייצוא פרטי המסמכים',
        exp_report_data: 'ייצוא נתוני הדוח',
    },
};
